var osm;
var googleStreets;
var googleStreetsCout;
var googleStreetsApres;
var googleStreetsTerrainAgricoleBoise;
var googleHybrid;
var googleHybridApres;
var googleSat;
var googleSatApres;
var googleTerrain;
var googleTerrainApres;
var Inventaire_Ecoforestier;
var circulation_routier;
var aq_camion;
var lidar_ombre;
var bgr_v_sous_route_res_sup_act;
var blank;
var liste_carte_de_base;
var privateKeyidMapkitMutant;
var roads;
var currentIdModule;
var video;
var mediaStreamTracks;
var origine_champ;
var origine_champ_id;
var nbErreurs = 0;

const success_msg = 'Sauvegarde réussie';
var WIZARD_ENTETE = Object.freeze({"taille": 200});
var ID_FORMULAIRE = Object.freeze({
    "residentiel": '2', "multi": '3', "terrainGeneral": '4', "terrainAgricoleBoise": '5',
    "agricole": '6', "nonResidentiel": '7', "renseignementAdministratif": '1', "resultatEvaluation": '8'
}); // pris de la table formulaire et est utilisé par la table bloc_x_formulaire de la vue
var TYPE_BATIMENT = Object.freeze({
    "residentiel": '1', "multi": '3', "agricole": '2', "nonResidentiel": '4'
}); // pris de la table formulaire et est utilisé par la table bloc_x_formulaire de la vue

var TYPE_EVENEMENT = Object.freeze({
    'permis': 1,
    'mutation': 2,
    'actualisation_inventaire': 3,
    'revision_recours': 4,
    'operation_cadastrale': 5,
    'enquete_vente': 6,
    'correction_mineure': 9,
    'annulation_ue': 24,
    'operation_ue': 32,
    'correction_mineure_vp': 33,
    'correction_mineure_proprietaire': 34,
    'changement_terrain': 35,
    'demande_de_revision': 61,
    'recours_au_tribunal': 62,
    'correction_d_office': 63,
    'correction_erreur_ecriture': 64,
    'nouveau_role': 50
});

var TYPES_MODELE_RETENU_REVENU = Object.freeze({
    'tga_manuel': 4,
    'mrb_manuel': 8,
    'aucun': 9,
    'manuel': 10
});

var ICONES_EN_IMAGE = Object.freeze(['.pdf', '.xls', '.xlsx', '.ods', '.doc', '.docx', '.jpeg', '.jpg', '.gif', '.png', '.jnt', '.zip', '.csv']);

var FORMULAIRE_CSS = {};
FORMULAIRE_CSS[ID_FORMULAIRE.residentiel] = 'fiche-residentiel';
FORMULAIRE_CSS[ID_FORMULAIRE.multi] = 'fiche-multi';
FORMULAIRE_CSS[ID_FORMULAIRE.terrainGeneral] = 'fiche-terrain-general';
FORMULAIRE_CSS[ID_FORMULAIRE.terrainAgricoleBoise] = 'fiche-terrain-agricole';
FORMULAIRE_CSS[ID_FORMULAIRE.agricole] = 'fiche-agricole';
FORMULAIRE_CSS[ID_FORMULAIRE.nonResidentiel] = 'fiche-non-residentiel';
FORMULAIRE_CSS[ID_FORMULAIRE.renseignementAdministratif] = 'fiche-admin';
FORMULAIRE_CSS[ID_FORMULAIRE.resultatEvaluation] = 'resultat-evaluation';

var OPTION_STATUT = Object.freeze({"aucun": 0, "ajout": 1, "suppresssion": 2});

var ModeSave = Object.freeze({
    'FICHE': 1,
    'WIZARD': 2,
    'MENU': 3,
    'VALEUR_TERRAIN': 4,
    'MODAL': 5,
});

var RAPPORT = Object.freeze({
    bilan_projet_sous_lot: 10,
    bilan_projet_detaille: 11,
    facturation_sommaire: 12,
    tec: 16,
    communication: 18,
    suivi_avancement: 19,
    releve_temps_depenses: 20,
    responsable_execution: 21,
    planification_inspection: 22,
    planification_inspection_ue: 23,
    gestion_route: 24,
    equilibration: 25,
    unite_evaluation: 26,
    mutations: 27,
    responsable_execution_details: 37,
    rh_absences: 38,
    tenue_a_jour: 54,
    mes_routes_inspection: 58,
    calendrier: 59,
    regroupement: 64,
    ivu: 65,
    registre_construction: 68,
    vfe: 69,
    revisions_administrative: 71,
    evenement_en_cours: 78,
    nombres_dossiers_traites: 74,
    delais_moyens_traitement: 73,
    analyse_revenu: 79,
    mise_a_jour_sig: 83,
});

var idModuleStartup; //VARIABLE GLOBALE IDENTIFIANT LE MODULE EN COURS

var wait_is_active = false;


moment.locale('fr', {
    months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
    monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
    weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
    weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
    weekdaysMin: "Di_Lu_Ma_Me_Je_Ve_Sa".split("_"),
    longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY LT",
        LLLL: "dddd D MMMM YYYY LT"
    },
    calendar: {
        sameDay: "[Aujourd'hui à] LT",
        nextDay: '[Demain à] LT',
        nextWeek: 'dddd [à] LT',
        lastDay: '[Hier à] LT',
        lastWeek: 'dddd [dernier à] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: "dans %s",
        past: "il y a %s",
        s: "quelques secondes",
        m: "une minute",
        mm: "%d minutes",
        h: "une heure",
        hh: "%d heures",
        d: "un jour",
        dd: "%d jours",
        M: "un mois",
        MM: "%d mois",
        y: "une année",
        yy: "%d années"
    },
    ordinalParse: /\d{1,2}(er|ème)/,
    ordinal: function (number) {
        return number + (number === 1 ? 'er' : 'ème');
    },
    meridiemParse: /PD|MD/,
    isPM: function (input) {
        return input.charAt(0) === 'M';
    },
    // in case the meridiem units are not separated around 12, then implement
    // this function (look at locale/id.js for an example)
    // meridiemHour : function (hour, meridiem) {
    //     return /* 0-23 hour, given meridiem token and hour 1-12 */
    // },
    meridiem: function (hours, minutes, isLower) {
        return hours < 12 ? 'PD' : 'MD';
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4  // The week that contains Jan 4th is the first week of the year.
    }
});

var spinnerOptions = {
    lines: 13, // The number of lines to draw
    length: 20, // The length of each line
    width: 10, // The line thickness
    radius: 30, // The radius of the inner circle
    corners: 1, // Corner roundness (0..1)
    rotate: 0, // The rotation offset
    direction: 1, // 1: clockwise, -1: counterclockwise
    color: '#000', // #rgb or #rrggbb or array of colors
    speed: 0.6, // Rounds per second
    trail: 60, // Afterglow percentage
    shadow: false, // Whether to render a shadow
    hwaccel: false, // Whether to use hardware acceleration
    className: 'spinner', // The CSS class to assign to the spinner
    zIndex: 2e9, // The z-index (defaults to 2000000000)
    top: 'auto', // Top position relative to parent in px
    left: 'auto' // Left position relative to parent in px

};

var spinnerSmallOptions = {
    lines: 11, // The number of lines to draw
    length: 4, // The length of each line
    width: 2, // The line thickness
    radius: 4, // The radius of the inner circle
    scale: 1, // Scales overall size of the spinner
    corners: 1, // Corner roundness (0..1)
    color: '#ffffff', // #rgb or #rrggbb or array of colors
    opacity: 0.25, // Opacity of the lines
    rotate: 0, // The rotation offset
    direction: 1, // 1: clockwise, -1: counterclockwise
    speed: 1, // Rounds per second
    trail: 60, // Afterglow percentage
    fps: 20, // Frames per second when using setTimeout() as a fallback for CSS
    zIndex: 2e9, // The z-index (defaults to 2000000000)
    className: 'spinner', // The CSS class to assign to the spinner
    top: '50%', // Top position relative to parent
    left: '50%', // Left position relative to parent
    shadow: false, // Whether to render a shadow
    hwaccel: false, // Whether to use hardware acceleration
    position: 'absolute', // Element positioning
};

var spinner = new Spinner(spinnerOptions);

var spinnerSmall = new Spinner(spinnerSmallOptions);

//PERMET DE SUIVRE TOUS LES CALL AJAX AVEC GOOGLE ANALYTICS
$(document).on('ajaxComplete', function (event, request, settings) {
    if (typeof (gtag) == 'function') {
        gtag('send', 'page_view', {page_path: settings.url});
    }
});

$(function () {
    $('[data-rel="tooltip"]').tooltip({container: 'body'});

    $(document).off("click", ".btn-close-modal-overlay").on("click", ".btn-close-modal-overlay", function () {
        $(this).closest(".modal").modal("hide");
        $('body').addClass('modal-open');
    });
});

/*FUELUX DATASOURCETREE (PROVENANT DU SAMPLEDATA.JS)*/
var DataSourceTree = function (options) {
    this._data = options.data;
    this._delay = options.delay;
};

DataSourceTree.prototype.data = function (options, callback) {
    var $data = null;

    if (!("name" in options) && !("type" in options)) {
        $data = this._data;//the root tree
        callback({data: $data});
        return;
    } else if ("type" in options && options.type == "folder") {
        if ("additionalParameters" in options && "children" in options.additionalParameters)
        $data = options.additionalParameters.children;
        else $data = {};
    }

    if ($data != null)//this setTimeout is only for mimicking some random delay
        setTimeout(function () {
            callback({data: $data});
        }, parseInt(Math.random() * 500) + 200);

    //we have used static data here
    //but you can retrieve your data dynamically from a server using ajax call
    //checkout examples/treeview.html and examples/treeview.js for more info
};


//ON AJOUTE AUTOMATIQUEMENT LE PRÉFIXE DU SITE (EX: INTRANET) À L'ENSEMBLE DES URLS
$.ajaxSetup({
    beforeSend: function (jqXHR, settings) {
        // Fonction Utilisée pour les appels Ajax pour le jeton CSRF.
        // Utilisation de settings.crossDomain pour remplacer SameOrigin logic trouvé dans JQuery 1.5 (bug).
        if (!securite.csrfSafeMethod(settings.type) && !this.crossDomain) {
            jqXHR.setRequestHeader("X-CSRFToken", securite.reqCSRFToken());
        }
    }
});


function base64ToArrayBuffer(base64) {
    base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
    var binaryString = atob(base64);
    var len = binaryString.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}



function pageGestionNotification() {
    wait.start();
    getNotificationParMunicipalite('#table-notification-administration-profil', 'current');
    $('#form_modal_gestion_notification').modal({
        show: true,
        backdrop: 'static'
    });
    wait.stop();
}


//-----------------------------------------------------------------------------------------------------------------------------------
// fonction global pour certains control
//-----------------------------------------------------------------------------------------------------------------------------------

function init_input_file(my_input_file) {

    var nom_fichier_complet = $('#' + my_input_file).attr('value');
    var nom_fichier = 'None';
    if (nom_fichier_complet != 'None') {
        var list_nom = nom_fichier_complet.split("/");
        var nombre_element_list = list_nom.length;
        nom_fichier = list_nom[nombre_element_list - 1];
    }

    if (nom_fichier != 'None') {

        //$('#' + my_input_file).parent().find('span').attr('data-title',nom_fichier);

        $('#' + my_input_file).attr('type', 'text');
        $('#' + my_input_file).attr('disabled', 'disabled');
        $('#' + my_input_file).addClass('form-control');


    } else {
        $('#' + my_input_file).ace_file_input({
            //$( "input[type='file']" ).ace_file_input({
            no_file: 'Pas de fichier ...',
            btn_choose: 'Choisir',
            btn_change: 'Changer',
            droppable: false,
            onchange: null,
            thumbnail: false, //| true | large
            whitelist: 'gif|png|jpg|jpeg|zip|pdf'
            //blacklist:'exe|php'
            //onchange:''
            //
        });

    }

}


function init_save_input_file(my_form, my_url, callback, callback_error, estMultiple, paramsSupp, dataType) {
    if (typeof (estMultiple) == 'undefined') {
        estMultiple = false;
    }
    if (typeof (paramsSupp) == 'undefined' || paramsSupp == null) {
        paramsSupp = {};
    }
    dataType = dataType || 'html';

    var $form = $('#' + my_form);
    $form.on('submit', function () {
        $('button[data-type="save"]').attr('disabled', 'disabled');
    });
    var submit_url = my_url;

    var file_input = $form.find('input[type=file]');

    var deferred;

    var files = file_input.data('ace_input_files');

    if ("FormData" in window && !(typeof files === 'undefined' || files == null)) {
        var fd = new FormData();

        Object.keys(paramsSupp).forEach(function (key) {
            fd.append(key, paramsSupp[key]);
        });
        $form.serializeArray().forEach(function (item) {
            fd.append(item.name, item.value);
        });

        // Then append ACE files manually
        var aceFiles = file_input.data('ace_input_files'); // always filled for both choose + drop
        if (aceFiles && aceFiles.length > 0) {
            for (var i = 0; i < aceFiles.length; i++) {
                fd.append(file_input.attr('name'), aceFiles[i]);
            }
        }

        deferred = $.ajax({
            url: submit_url,
            type: $form.attr('method'),
            processData: false,
            contentType: false,
            //async: false,
            dataType: 'html',
            data: fd,

            success: function (response) {

                if (response != 'saved' && !json_sauvegarde_ok(response)) {
                    callback_error(response);
                } else {
                    callback(response);
                }

            },

            error: function (xhr, textStatus, thrownError) {
                callback_error(thrownError + ': ' + textStatus);
            }
        });

        deferred.promise();

    } else { /*HACK POUR IE<10 QUI NE SUPPORTE PAS FORMDATA POUR UPLOAD AJAX*/


        if (!(typeof files === 'undefined' || files == null)) {

            $form.fileupload({
                url: submit_url, done: function (e, data) {

                    var response = data.result[0].body.innerHTML;

                    if (response != 'saved') {
                        callback_error(response);
                    } else callback(response);


                }, fail: function () {
                    callback_error('error');
                }

            });

            $form.fileupload('send', {
                fileInput: $form.find('input[type=file]')//$('#id_path_commande')
            });

        } else { //SI AUCUN FICHIER N'EST SÉLECTIONNÉ, ON ENVOIE LE FORM AVEC UN AJAX NORMAL

            var params = $form.serialize();

            $.ajax({
                type: $form.attr('method') ? $form.attr('method') : "POST",
                url: submit_url,
                data: params,
                dataType: dataType,
                success: function (response) {
                    if (response != 'saved' && !json_sauvegarde_ok(response)) {
                        callback_error(response);
                    } else {
                        callback(response);
                    }
                },
                error: function (xhr) {
                    callback_error(xhr.responseText);
                }

            });
        }

    }

    //};


    return false;
}

function json_sauvegarde_ok(json) {
    try {
        return JSON.parse(json).sauvegarde === 'ok';
    } catch (e) {
    }
    return false;
}

function init_dateRangePicker(selecteur) {
    if (typeof selecteur === 'undefined') {
        selecteur = $('*');
    }

    selecteur.find('input[name=date-range-picker]').each(function () {
        //On doit calculer le offset de l'écran gauche
        var offsetInput = $(this).offset();
        var gauche = offsetInput.left;
        var opens = gauche < 500 ? 'right' : 'left';
        var opts = {
            singleDatePicker: $(this).hasAttr('singledatepicker'),
            todayHighlight: true,
            opens: opens,
            autoUpdateInput: false,
            autoApply: $(this).hasAttr('singledatepicker'),
            applyButtonClasses: 'btn-success',
            alwaysShowCalendars: true,
        };
        if (!$(this).hasAttr('singledatepicker')) {
            opts.ranges = {
                "Aujourd'hui": [new Date()],
                "7 derniers jours": [moment().subtract(6, 'days'), new Date()],
                "Mois courant": [moment().startOf('month'), moment().endOf('month')],
                "Mois précédent": [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            };
        }

        $(this).daterangepicker(opts).prev().on(ace.click_event, function () {
            //show datepicker when clicking on the icon.
            $(this).next().focus();
        });

        if ($(this).hasAttr('estdatedernierjoursemaine')) {
            $(this).on('keypress', function (e) {
                var value = $(this).data('daterangepicker').startDate;
                if (e.keyCode === 13 && !$(this).data('daterangepicker').isInvalidDate(value)) {
                    $(this).trigger('apply.daterangepicker');
                }
            });

            // On empêche le user d'écrire dans le input (pour avoir le même comportement que dans admin hebdo)
            $(this).on('keydown', function (e) {
                e.preventDefault();
            });

            $(this).daterangepicker({
                isInvalidDate: function (date) {
                    return date.day() !== 5;
                    },
                    locale: {
                        firstDay: 6 //semaine commence par samedi (même principe que feuille de temps)
                    },
                    autoUpdateInput: false
                });
        }

        $(this).on('apply.daterangepicker', function (ev, picker) {
            if ($(this).hasAttr('singledatepicker')) {
                $(this).val(picker.startDate.format('YYYY-MM-DD'));
            } else {
                $(this).val(picker.startDate.format('YYYY-MM-DD') + ' - ' + picker.endDate.format('YYYY-MM-DD'));
            }
        });

        $(this).on('cancel.daterangepicker', function () {
            $(this).data('daterangepicker').container.find('td.active:not(.today)').removeClass('active');
            $(this).val('');
        });
    });
}

var initializing_date_picker = false;

function destroyDatepicker(element) {
    if ($(element).data('daterangepicker')) $(element).data('daterangepicker').remove();
}

function destroyAllDatepickers(container) {
    $(container).find('.dateinput').each(function () {
        destroyDatepicker(this);
    });
}

function initDatepickerWithOptions(element, options, destroy_before) {
    if (destroy_before === true) {
        $(element).data('daterangepicker').remove();
    }
    $(element).daterangepicker(options);
    if (typeof (options.autoUpdateInput) !== 'undefined' && options.autoUpdateInput === false) {
        $(element).on('apply.daterangepicker', function (ev, picker) {
            $(this).val(picker.startDate.format('YYYY-MM-DD'));
            $(this).trigger('change');
        });
    }
    if ($(element).next().hasClass('input-group-addon')) {
        $(element).next().on(ace.click_event, function () {
            $(this).prev().focus();
        });
    }
}

function init_date_picker(selecteur) {
    initializing_date_picker = true;

    if (typeof selecteur === 'undefined') {
        selecteur = $('body');
    }
    var parentEl;

    $.each(selecteur.find('.dateinput, .datepicker, .date-picker, .input-group.date').not('.max-today, .min-today, .max-date').not(':disabled'), function () {
        parentEl = $(this).closest('.modal').length > 0 ? '.modal' : 'body';
        if (!$(this).data('daterangepicker')) {
            $(this).daterangepicker({
                autoUpdateInput: false,
                parentEl: parentEl,
                autoApply: true,
                ranges: {
                    "Aujourd'hui": [moment(), moment()]
                },
                showCustomRangeLabel: false
            }).on('apply.daterangepicker', function (ev, picker) {
                $(this).val(picker.startDate.format('YYYY-MM-DD'));
                $(this).trigger('change');
            }).next().on(ace.click_event, function () {
                $(this).prev().focus();
            });
        }

    });
    parentEl = 'body';
    if (selecteur.closest('.datepicker-container').length > 0) {
        parentEl = '.datepicker-container';
    } else if (selecteur.closest('.modal').length > 0) {
        parentEl = '.modal';
    }

    selecteur.find('.max-today').daterangepicker({
        maxDate: new Date(),
        autoUpdateInput: false,
        parentEl: parentEl,
        autoApply: true,
    }).next().on(ace.click_event, function () {
        $(this).prev().focus();
    });

    selecteur.find('.max-today').on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('YYYY-MM-DD'));
    });

    var selecteurMaxDate = selecteur.find('.max-date');
    $.each(selecteurMaxDate, function () {
        $(this).daterangepicker({
            maxDate: $(this).attr('max-date'),
            autoUpdateInput: false,
            parentEl: parentEl,
            autoApply: true,
        }).next().on(ace.click_event, function () {
            $(this).prev().focus();
        });
    });

    selecteur.find('.max-date').on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('YYYY-MM-DD'));
    });

    var max_date = new Date();
    max_date.setFullYear(max_date.getFullYear() + 1);
    selecteur.find('.max-365').daterangepicker({
        autoUpdateInput: false,
        maxDate: max_date,
        parentEl: parentEl,
        autoApply: true,
    }).next().on(ace.click_event, function () {
        $(this).prev().focus();
    });

    selecteur.find('.max-365').on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('YYYY-MM-DD'));
        $(this).trigger('change');
    });

    parentEl = selecteur.find('.min-today').closest('.modal').length > 0 ? '.modal' : 'body';

    selecteur.find('.min-today').daterangepicker({
        minDate: new Date(),
        autoUpdateInput: false,
        parentEl: parentEl,
        autoApply: true,
    }).next().on(ace.click_event, function () {
        $(this).prev().focus();
    });
    selecteur.find('.min-today').on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('YYYY-MM-DD'));
        $(this).trigger('change');
    });

    initializing_date_picker = false;
}

function init_table(my_table, nbColonnes, triInitial) {


    $('table th input:checkbox').on('click', function () {
        var that = this;
        $(this).closest('table').find('tr > td:first-child input:checkbox')
            .each(function () {
                this.checked = that.checked;
                $(this).closest('tr').toggleClass('selected');
            });
    });


    var col = [];
    col.push({"bSortable": true});

    for (var i = 0; i < nbColonnes; i++) {
        col.push(null);
    }

    col.push({"bSortable": false, "sWidth": "125px"}); //ON DONNE PLUS D'ESPACE À LA DERNIÈRE COLONNE POUR QUE LES BOUTONS S'AFFICHENT HORIZONTALEMENT

    initTableDatatable("#" + my_table, {

        "aoColumns": col,
        "iDisplayLength": -1, //tous
        "aLengthMenu": [[-1, 10, 25, 50], ["Tous", 10, 25, 50]],
        "aaSorting": triInitial,
        "language": {
            "sProcessing": "Traitement en cours...",
            "sSearch": "Rechercher&nbsp;:",
            "sLengthMenu": "Afficher _MENU_ &eacute;l&eacute;ments",
            "sInfo": "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments",
            "sInfoEmpty": "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ments",
            "sInfoFiltered": "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
            "sInfoPostFix": "",
            "sLoadingRecords": "Chargement en cours...",
            "sZeroRecords": "Aucun &eacute;l&eacute;ment &agrave; afficher",
            "sEmptyTable": "Aucune donnée disponible dans le tableau",
            "oPaginate": {
                "sFirst": "Premier",
                "sPrevious": '<i class="ace-icon fa fa-angle-double-left"></i>',//"Pr&eacute;c&eacute;dent",
                "sNext": '<i class="ace-icon fa fa-angle-double-right"></i>',//"Suivant",
                "sLast": "Dernier"
            },
            "oAria": {
                "sSortAscending": ": activer pour trier la colonne par ordre croissant",
                "sSortDescending": ": activer pour trier la colonne par ordre décroissant"
            }
        }
    });

}

/**
 * Afficher un message dans une banniere.
 * @param {string} divId - Sélecteur utilisé pour le DOM.
 * @param {string} message - Message d'erreur.
 */
function reqBanniereMessage(divId, message, niveauClasse) {
    return '<div id="' + divId + '" class="alert ' + niveauClasse + ' banniere">' +
        '<button data-dismiss="alert" class="close" type="button"> ' +
        '<i class="ace-icon fa fa-times"></i>' +
        '</button>' +
        '<strong>' +
        '<i class="ace-icon fa fa-times"></i>' +
        '</strong>' + ' ' +
        message +
        '<br>' +
        '</div>';
}


/**
 * Fonction d'arrondissement avant d'envoyer les données pour la sauvegarde à l'étape de la valeur retenue.
 * @param {number} montant - Sélecteur de champ ou de balise.
 * @param {number} arrondirAu - Par défaut, montant arrondi au 100$.
 * */
function entierArrondirAu(montant, arrondirAu) {
    var arrondiAu = arrondirAu !== undefined ? arrondirAu : 100;
    var resultat = montant;
    var nombreModulo = resultat % arrondiAu;
    if (nombreModulo >= (arrondiAu / 2)) {
        resultat = +resultat - nombreModulo + arrondiAu;
    } else {
        resultat = resultat - nombreModulo;
    }
    return resultat;
}


/**
 * Initialiser à la demande le formatage monétaire d'un champ
 * @param {string} selecteur - Sélecteur utilisé pour initialiser le format monétaire canadien.
 * @param {number} nombreDecimales - Nombre de décimales utilisées pour le formatage.
 * */
function formaterMonnaie(selecteur, nombreDecimales) {
    selecteur.autoNumeric("init", {
        aSep: ' ',
        aDec: ',',
        aSign: ' $',
        mDec: nombreDecimales,
        pSign: 's',
        wEmpty: 'empty'
    });
}

function formatDecimalWithThousandSeparator(objet) {
    IMask(objet, {
        mask: Number,
        scale: 4,
        thousandsSeparator: ' ',
        normalizeZeros: false,
        radix: '.',  // fractional delimiter
        mapToRadix: [','],  // symbols to process as radix
    });
}

/**
 * Initialiser à la demande le formatage de superficie d'un champ
 * @param {string} selecteur - Sélecteur utilisé pour initialiser le format.
 * @param {number} nombreDecimales - Nombre de décimales utilisées pour le formatage.
 * */
function formaterSuperficie(selecteur, nombreDecimales) {
    selecteur.autoNumeric("init", {
        aSep: ' ',
        aDec: ',',
        aSign: ' m²',
        mDec: nombreDecimales,
        pSign: 's'
    });
}

/**
 * Focus sur l'élément dans la page HTML
 * @desc Le contrôle permet de souligner avec effet l'erreur qui n'est pas corrigée.
 * @param {string} element - élément utilisé pour l'alerte. Créé pour savoir si la bannière existe déjà. si div, on utilise '#contenu', si classe, on utilise '.contenu', etc... Si on souhaite afficher un message, on doit sélectionner un id d'un div. On peut par contre surligner tout élément, par exemple : focusControle('input[name="no_permis"]', '', '', 5). Dans ce cas, on n'a pas besoin de définir divCadre.
 * @param {number} niveau - 1 = succès, 2 = info, 3 = alerte, 4 = danger (erreur), 5 = normal (rien du tout et uniquement pour souligner une information).
 * @param {string} divCadre - Élément sur lequel faire un append du message (alerte).
 * @param {string} message - Message d'erreur.
 *
 */
function focusControle(element, niveau, divCadre, message) {
    var couleurFondFin;
    var couleurFondDepart;
    var niveauClasse;
    var dureeEffet;
    var effetFlash;

    if (niveau === 4) {
        couleurFondDepart = '#d5959f';
        couleurFondFin = '#f2dede';
        niveauClasse = 'alert-danger';
        dureeEffet = 950;
        effetFlash = false;
    } else if (niveau === 5) {
        couleurFondDepart = '#d5959f';
        couleurFondFin = '#ffffff';
        niveauClasse = '';
        dureeEffet = 1500;
        effetFlash = false;
    }
    var divFocus;

    if (element.indexOf('.') !== -1) {
        divFocus = $(element); //$divFocus (on met en surbrillance ou on souligne une erreur répétitive)
        divCadre = $('#' + divCadre); //$divCadre
    } else {
        divFocus = $(element).filter(":last"); //$divFocus (on met en surbrillance ou on souligne une erreur répétitive)
        divCadre = $('#' + divCadre).filter(":last"); //$divCadre
    }

    if (divFocus.length > 0) {
        if (effetFlash) {
            for (var i = 0; i < 2; i++) {
                divFocus
                    .animate({backgroundColor: couleurFondDepart}, 75)
                    .animate({backgroundColor: couleurFondFin}, 75);
            }
            divFocus.animate({backgroundColor: couleurFondDepart}, 1).animate({backgroundColor: couleurFondFin}, dureeEffet, function () {
                divFocus.removeAttr('style');
            });
        } else {
            divFocus.animate({backgroundColor: couleurFondDepart}, 1).animate({backgroundColor: couleurFondFin}, dureeEffet, function () {
                divFocus.removeAttr('style');
            });
        }

    } else {
        divCadre.append(reqBanniereMessage(element, message, niveauClasse));
    }
}

function getBanniereMessage(prefixe, message) {
    return '<div class="alert alert-danger banniere">' +
        '<button data-dismiss="alert" class="close" type="button">' +
        '<i class="ace-icon fa fa-times"></i>' +
        '</button>' +
        '<strong>' +
        '<i class="ace-icon fa fa-times"></i>' +
        ' ' + prefixe + ' ' +
        '</strong>' +
        message +
        '<br>' +
        '</div>';
}

function removeBanniere(){
	$('.banniere').remove();
}

function nettoyerTitre(titre) {
    var resultat = titre;
    resultat = resultat.replace(/(\r\n|\n|\r)/gm, ""); // Retirer les retours de lignes
    resultat = resultat.replace(/\s+/g, " "); // Retirer les doubles espaces blancs
    resultat = resultat.replace(/\*\*/g, " "); // Retirer les "**" du clone s'il y a lieu, '**' étant l'indicateur pour les travaux de la demande originale.
    return resultat;
}

function getBootstrapCurrentSize() {
    var envs = ['xs', 'sm', 'md', 'lg'];

    var $el = $('<div>');
    $el.appendTo($('body'));

    for (var i = envs.length - 1; i >= 0; i--) {
        var env = envs[i];

        $el.addClass('hidden-' + env);
        if ($el.is(':hidden')) {
            $el.remove();
            return env;
        }
    }
}

// Namespace réserver à l'activation de opt-in de Bootstrap ou à l'optimisation.
var bootstrapOn = {

    // Initialisation des tooltips de Bootstrap : opt-in
    initTooltips: function () {
        $('[data-toggle="tooltip"]').tooltip();
    }

}; // namespace bootstrapOn


// Espace de noms réservés aux contrôles de formulaires.
var controlesFormulaires = {
    serialiserFormulaire: function (currentForm) {
        var dataType = currentForm.attr('data-type');
        var currentLevel = currentForm.find('[data-type^="' + dataType + '"]')[0] === undefined ? currentForm : $(currentForm.find('[data-type^="' + dataType + '"]')[0]); // On ne récupère que le formulaire courant. On ne veut pas les enfants (les types des natures) qui sont descendants.

        // ne pas sérializer les inputs qui sont dans les sous-blocs au travers du formulaire, ils seront gérés dans la sauvegarde des sous-blocs
        var exclusionCurrentLevel = [];
        var exclusionInputMoney = [];
        var exclusionInputSuperficie = [];
        if (!currentForm.is('.sous-bloc-form')) {
            exclusionCurrentLevel = currentLevel.find('.sous-bloc-form :input');
            exclusionInputMoney = currentLevel.find('.sous-bloc-form :input.money');
            exclusionInputSuperficie = currentLevel.find('.sous-bloc-form :input.superficie');
        }
        // si la date de l'évènement est disabled, par exemple l'enquête de vente, on la met enabled pour sérializer les données
        var dateEvenementDisable = currentLevel.filter('[data-type=date_effective-evenement]').find(':input:disabled').attr('disabled', false);
        var params = currentLevel.find(':input:not(:checkbox)').not(':input.money').not(':input.superficie').not(exclusionCurrentLevel).serializeArray();
        // il faut remettre la date_de l'évènement disabled, comme son état initial
        dateEvenementDisable.attr('disabled', true);
        var inputsDisabled = currentLevel.find('input:disabled');
        inputsDisabled.removeAttr('disabled');
        var paramsDisabledChecked = currentLevel.find(':input:disabled:checked').not(':input.money').not(':input.superficie').not(exclusionCurrentLevel); // Hack poche : Le serialize() et le serializeArray() ne ramassent pas les éléments disabled (voir https://www.w3.org/TR/html401/interact/forms.html#h-17.13.2)
        $.each(paramsDisabledChecked, function (index, value) {
            params.push({name: $(value).attr('name'), value: $(value).prop('checked')});
        });
        var paramsMoney = currentLevel.find(':input.money').not(exclusionInputMoney);
        $.each(paramsMoney, function (index, value) {
            var objet = {};
            objet.name = value.name;
            objet.value = $(value).autoNumeric('get');
            params.push(objet);
        });
        var paramsSuperficie = currentLevel.find(':input.superficie').not(exclusionInputSuperficie);
        $.each(paramsSuperficie, function (index, value) {
            var objet = {};
            objet.name = value.name;
            objet.value = $(value).autoNumeric('get');
            params.push(objet);
        });
        $.each(params, function (index, value) {
            if (value.name === 'date_evenement') {
                if (value.value !== '') {
                    value.value = value.value + 'T15:00:00';
                }
                /*else if (value.value === '' || value.value.length === 0) { // On supprime le champs, s'il est vide, pour avoir un message d'erreur et de validation autre que le format incorrect.
                 params.splice(index, 1); // on utilise une itération sur params dans views.py. On ne peut utiliser delete qui ne supprime que le contenu : reste avec un index vide sur lequel on ne peut itérer (clé et valeur suprimés)
                 }*/
            }
        });
        // Ajouter les checkbox checked, vu que ça met value='on' plutôt que de mettre 1
        var checkboxChecked = $(currentLevel).find(':checkbox:checked').not('.ctrl-suppression');
        $.each(checkboxChecked, function (index, element) {
            var $element = $(element);
            params.push({name: $element.attr('name'), value: 1});
        });
        // Ajouter les checkbox unchecked
        var checkboxUnchecked = $(currentLevel).find(':checkbox:not(:checked)').not('.ctrl-suppression');
        $.each(checkboxUnchecked, function (index, element) {
            var $element = $(element);
            // prendre la valeur pour le false s'il y a lieu
            var valueFalse = $element.attr('value_false');
            params.push({name: $element.attr('name'), value: valueFalse != undefined ? valueFalse : 0});
        });
        inputsDisabled.attr('disabled', true);
        return params;
    },


    /**
     * Fonction qui permet de redimentionner des textareas pour s'ajouter au contenu. Travaille de manière conjointe au slimScroll (si dans un modal).
     *
     */
    redimentionnerTextarea: function () {

        $.each(jQuery('textarea'), function () {

            var offset = this.offsetHeight - this.clientHeight;

            // Si on a déjà du contenu, on ajuste la hauteur du textarea pour ne pas voir les contrôles de défilement.
            if (this.scrollHeight) {
                $(this).css('height', this.scrollHeight + offset);
            }

            var redimentionnerPourContenu = function (el) {
                $(el).css('height', 'auto').css('height', el.scrollHeight + offset);
            };
            $(this).off('keyup input').on('keyup input', function () {
                redimentionnerPourContenu(this);
            });
        });
    },

    /**
     * Fonction qui permet de retirer des accents dans des champs majuscules (propriétaires et adresses)
     *
     */
    retirerAccents: function () {
        $('#modal-message-alerte').off('change').on('change', 'input.upper', function () { // #modal-message-alerte
            var accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
            var accentsOut = "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
            var valeurChamp = $(this).val();
            valeurChamp = valeurChamp.split('');
            var strLen = valeurChamp.length;
            var i, x;
            for (i = 0; i < strLen; i++) {
                if ((x = accents.indexOf(valeurChamp[i])) != -1) {
                    valeurChamp[i] = accentsOut[x];
                }
            }
            $(this).val(valeurChamp.join(''));
        });
    },


    /**
     * Fonction de détection des changements dans un formulaire.
     *
     */

    readOnlyFormulaire: function () {
        $("#contenu :input").attr('readonly', 'readonly');

        $('select', $('#contenu')).each(function () {
            var exceptionChangementNotifie = $(this).is('#sommaire-select-type-batiment, #sommaire-select-no-batiment');
            if (!exceptionChangementNotifie) {
                $(this).prop('disabled', true);
            }
        });

    },


    detecterChangementsFormulaire: function () {
        $(document).on('input', 'input.search-query', function () { // Détection des changements dans la boîte de recherche.
            if ($(this).val() === "") {
                $(this).parent().find('button#recherche').prop("disabled", true);
            } else {
                $(this).parent().find('button#recherche').prop("disabled", false);
            }
        });

        /**
         * Détection des changements de champs pour activation du bouton sauvegarder.
         *
         */
        $('#contenu :text, textarea').on("keypress", function (e) { // texte saisi dans un champ.
            controlesFormulaires.modifEtatSauvegarde(e);
        });

        $('#contenu :text, textarea').on("keyup", function (e) {
            if (e.keyCode == 8 || e.keyCode == 46) { // Utilisation de "Backspace" et "Delete".
                controlesFormulaires.modifEtatSauvegarde(e);
            } else { // On ne fait rien pour les autres touches utilisées.
                e.preventDefault();
            }
        });
        $('#contenu :text').bind("paste", function (e) { // Texte copié dans un champ.
            controlesFormulaires.modifEtatSauvegarde(e);
        });

        $('#contenu select').on("change", function (e) {
            controlesFormulaires.modifEtatSauvegarde(e);
        });

        // $("#contenu :input").on("change", function (e) {
        //     controlesFormulaires.modifEtatSauvegarde(e);
        // });

        $('#contenu :checkbox').on("change", function (e) {
            controlesFormulaires.modifEtatSauvegarde(e);
        });

        $('#contenu :radio').on("change", function (e) {
            controlesFormulaires.modifEtatSauvegarde(e);
        });

        $('#contenu').find('.date-picker, .dateinput').on("change", function (e) {
            // comparer avec la valeur précédente et ne pas faire de changement si c'est identique
            if (!$(this).attr('valeur-precedente') || $(this).attr('valeur-precedente') != $(this).val()) {
                // sans le IF, cet évènement est appelé sans qu'on le veuille lors du reload apres save
                if (typeof (initializing_date_picker) == 'undefined' || !initializing_date_picker) {
                    controlesFormulaires.modifEtatSauvegarde(e);

                    // garder la date comme étant la valeur précédente
                    $(this).attr('valeur-precedente', $(this).val());
                }
            }
        });

        $('#contenu .ace-input-file').on("change", function (e) {
            controlesFormulaires.modifEtatSauvegarde(e);

            // Issue #6307, correction pour FireFox seulement : quand on ajoute un fichier, il y a un interférence avec le
            // scrollbar caché du modal quand la hauteur du modal dépasse la hauteur de l'écran
            if (estFirefox()) {
                $('.modal').scrollTop(0);
            }
        });

    },

    modifEtatSauvegarde: function (e) {
        var exceptionChangementNotifie = $(this).is('#contenu-proprietaire-recherche :input, #contenu-attestation-infos input, input[name="checkbox-attestation-applique-a"], #checkbox-attestation-tous, #sommaire-select-type-batiment, #sommaire-select-no-batiment');
        var estSelect2Exception = $(e.target).is('.select2-input');
        var select2Parent = [];
        if (estSelect2Exception) {
            var idSelect2Search = $(e.target).attr('id');
            var index = idSelect2Search.indexOf('_search');
            select2Parent = $('#' + idSelect2Search.substr(0, index));
            estSelect2Exception = select2Parent.is('#contenu-proprietaire-recherche :input');
        }
        if (!exceptionChangementNotifie && !estSelect2Exception) {
            $('button[data-type="save"]').prop("disabled", false);

            // si c'est seulement un sous-bloc-form qui a changé, on ne veut pas sauvegarder tout le formulaire
            if ($(e.target).is('#bien-non-immobilier-mutation .sous-bloc-form :input, #rajustement-mutation .sous-bloc-form :input')) {
                $(e.target).closest('.sous-bloc-form').attr('modifie', 'True');
            } else {
                $(e.target).closest('div[type="formulaire"]').attr('modifie', 'True');
                $(e.target).closest('div[type="sous-formulaire"]').attr('modifie', 'True'); // Si un sous formulaire est présent (dans le cas de la nature et de la description des travaux, par exemple)...
                if ($(e.target).closest('div[type="formulaire"]').attr('id-model-instance') === 'None') { // Rapport d'inspection : Si une nature ou un type de travaux a été modifié et que l'instance de l'évènement est "None" ou contient "nouveau", on pousse également "date_effective-evenement".
                    var idSplit = $(e.target).closest('div[type="formulaire"]').attr('id').split('-');
                    var idSCible = idSplit.splice(0, 5).join('-');
                    var formulaireDateEffective = $('#' + idSCible + '[data-type="date_effective-evenement"]' + '[class*="visible-' + getBootstrapCurrentSize() + '"]');
                    if (idSCible.indexOf('nouveau') > 0) {
                        $(formulaireDateEffective).attr('modifie', 'True');
                    }
                }
                $(e.target).closest('.sous-bloc-form').attr('modifie', 'True');

                // DM: mini-hack: ne pas marquer ces blocs comme comme modifié sinon le save plante (anyway rien n'est savé au niveau du bloc, seulement au niveau du sous-bloc)
                var blocForm = $(e.target).closest('.blocForm');
                if ($.inArray(blocForm.attr('id'), ['b05-photo', 'b06-croquis', 'b22-mur-exterieur']) == -1) {
                    $(e.target).closest('.blocForm').attr('modifie', 'True');
                }

                if (select2Parent.length > 0) select2Parent.closest('.apres-container .blocForm').attr('modifie', 'True');
                $(e.target).closest('#sommaire-onglet-div').attr('modifie', 'True'); // méthode du coût dans le wizard
            }
        }
    },


    /**
     * Fonction de toggle de classe pour la fonction clearable.
     *
     */
    toggleAddRemoveClass: function (v) {
        return v ? 'addClass' : 'removeClass';
    },

    /**
     * Fonction qui permet l'ajout d'un bouton de suppression dans des inputs (filtres, etc).
     *
     */
    clearable: function () {
        var callback = $(document).off('input').on('input', '.clearable', function () {
            $(this)[controlesFormulaires.toggleAddRemoveClass(this.value)]('x');
        });
        controlesFormulaires.faitClearable(callback);
    },


    /**
     * Exécution auto et par déclenchement de clearable.
     * @desc Dans le cas où la fonction clearable n'est pas détectée par la modification d'un .val(), parce que la valeur
     * est modifiée par Javascript, on force le déclenchement de l'action non détectée.
     *
     * @param {function} Passe une fonction en callback pour l'exécution en mode manuel.
     *
     */
    faitClearable: function (callback) {
        callback.off('mousemove').on('mousemove', '.x', function (e) {
            $(this)[controlesFormulaires.toggleAddRemoveClass(this.offsetWidth - 18 < e.clientX - this.getBoundingClientRect().left)]('onX');
        }).on('click', '.onX', function () {
            $(this).removeClass('x onX').trigger('cancel.daterangepicker', this);
            $(this).val('');
            $('button#recherche').prop("disabled", true);
        });
    },


    /**
     * Fonction de sélection de tous les éléments d'une grille (visibles)
     * @param {string} selecteur - id ou classe principale pour les évènements deferred.
     * @param {string} cible - Chaine de la classe ou de l'ID à utiliser pour ce checkbox, par exemple.
     *
     */
    selectAll: function (tableElem, checkSelectAll) {

        var boutonsActionDisabled = false;
        var checkBoxes = tableElem.find(':checkbox.check-taj');

        if (checkSelectAll.is(':checked')) {
            boutonsActionDisabled = false;
            checkBoxes.prop('checked', true);
            tableElem.find('tr').addClass('selected');
        } else {
            boutonsActionDisabled = true;
            checkBoxes.prop('checked', false);
            tableElem.find('tr').removeClass('selected');
        }

        return boutonsActionDisabled;
    }

};


// Espace de nom réservé à la gestion des erreurs pour les appels Ajax
var erreursAjax = {
    /**
     * Fonction de traitement des erreurs.
     * @param {type} 0 : formulaire, 1: fiche.
     */
    traiterErreurs: function (form, xhr, thrownError) {
        erreursAjax.effacerErreurChamps(form);
        if (xhr.status === 400) {
            var erreurs = $.parseJSON(xhr.responseText);
            if ('formulaires' in erreurs) {
                $.each(erreurs.formulaires, function (index, value) {
                    $.each(value, function (formulaire, champs) {
                        $.each(champs, function (champ, valeur) {
                                var visibleBootstrap = $('#' + formulaire + '[type="formulaire"].visible-' + getBootstrapCurrentSize()).length === 1 ? '[class*="visible-' + getBootstrapCurrentSize() + '"]' : '';
                                erreursAjax.afficherErreurChamps($('#' + formulaire + '[type="formulaire"]' + visibleBootstrap), champ, valeur, xhr);
                            }
                        );
                    })
                    ;
                    $('.form.alert').fadeIn();
                });
            } else {
                $.each(erreurs, function (champ, valeur) {
                    erreursAjax.afficherErreurChamps(form, champ, valeur, xhr);
                    $('.form.alert').fadeIn();
                });
            }
            fenetreModal.calculerHauteurModal(form.closest('.modal'));
        }
    },


    /**
     * Fonction d'affichage des erreurs sous les champs dans les formulaires
     * @param {string} champ
     * @param {string} erreur
     */
    afficherErreurChamps: function (currentForm, champ, erreur, xhr, duplicata) {
        // si c'est un bloc, il ne faut pas trouver les champs dans les sous-blocs
        var exceptionsFormControl = [];
        if (currentForm.is('.blocForm')) {
            exceptionsFormControl = currentForm.find('.champs-multiple .form-control');
        } else {
            exceptionsFormControl = currentForm.find('.suppression-ligne .form-control, .suppression-ligne-sauvegardee .form-control');
        }

        if (currentForm.is('#evenement-wizard.blocForm')) {
            var etapeWizard = $('.step-pane.active');
            var champsDansEtape = etapeWizard.find('.form-control[name="' + champ + '"]').not(exceptionsFormControl).not(currentForm.find('.form-control')).not(etapeWizard.find('.form-control:hidden'));
            if (champsDansEtape.length) {
                currentForm = champsDansEtape.closest('.form-horizontal, .sous-bloc-form, .blocForm');
            }
        }

        var champs = currentForm.find('.form-control[name="' + champ + '"]').not(exceptionsFormControl);

        // DM 2019-07-16: ce IF semble plutôt être concu pour les étapes 3 et 5 des permis, section Bâtiment / Nature / Types travaux
        if (!currentForm.is('.sous-bloc-form') && !champs.is(':radio') &&
            currentForm.find('.form-control[name=' + champ + '], [class*="visible-' + getBootstrapCurrentSize() + '"]').length != 1) {
            if (!currentForm.is('.blocForm') && !currentForm.is('.champs-multiple')) { // pour bien afficher les erreurs de blocs par exemple dans l'étape de propagation
                champs = $(currentForm.find('[data-type$="' + currentForm.attr('data-type') + '"], [class*="visible-' + getBootstrapCurrentSize() + '"]').find('.form-control[name=' + champ + ']')); // On ne récupère que le formulaire courant. On ne veut pas les enfants (les types des natures) qui sont descendants.
            }
        }

        if (champs.length === 0) {
            var erreurMsg = erreur;
            if (champ && champ.toLowerCase() != 'none' && champ !== "non_field_errors" && champ.toLowerCase() != 'bidon') {
                erreurMsg = '[Champ: ' + champ + '] ' + erreurMsg;
            }

            if (currentForm.is('.div-table-contenu, .champs-multiple') || currentForm.is('.div-table-contenu, .blocForm')) {
                erreursAjax.afficherErreurGenerique(currentForm, 'append', xhr, erreurMsg);
            } else if (currentForm.is('.afficher-erreur')) {
                erreursAjax.afficherErreurGenerique(currentForm, 'after', xhr, erreurMsg);
            } else if (currentForm.is('.garder-warning')) {
                erreursAjax.afficherErreurGenerique(currentForm, 'append', xhr, erreurMsg, duplicata);
            } else if (currentForm.is('.filtres')) {
                erreursAjax.afficherErreurGenerique(currentForm, 'append', xhr, erreurMsg);
            } else {
                erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', xhr, erreurMsg);
            }
        }
        var champId = (currentForm.find(champs).attr('id') === '' || champs.attr('id') === undefined) ? champs : currentForm.find('#' + champs.attr('id')).not(exceptionsFormControl);
        if (champId.not('[type!="hidden"]')) {
            if (!$(currentForm).is('.type-warning')) {
                champId.addClass('form-border-alert-danger');
            }
            // Dans le cas de select2, le select original est caché (tabindex=-1) : on doit trouver sa représentation.
            champId.parent().find('.select2-container .select2-choice').css({'border': '1px solid #eb0d0f'});
            var niveauAlerte = $(currentForm).is('.type-warning') ? 'alert-warning' : 'alert-danger';
            var message = '<div class="message-erreur form alert ' + niveauAlerte + ' in"><p>' + erreur + '</p></div>';
            if (champId.is('input:file, input:checkbox')) {
                champId.parent().after(message);
                // Les input files (Ace) et les checkbox sont wrappés dans une balise <label> qui vient flinguer l'affichage du message. On corrige le tout.
            } else if (champId.is('input:radio')) {
                champId.last().parent().after(message);
                // si c'est un contrôle radio, alors afficher l'erreur en-dessous du dernier contrôle
            } else if (champId.closest('div').is('.input-group')) { // pour les select ou tout autre élément wrappé dans un input-group.
                champId.parent().after(message);
            } else {
                champId.after(message);
            }


            // On vérifie que le message et le champs sont plus courts (heigth) que le contenu de l'accordéon pour 'data-type="date_effective-evenement"', sinon, on étire. Uniquement valide dans le cas des accordéons vides de l'étape 5, pour l'instant.
            if (champs.length > 0) {
                var champsLongueur = champs.length;
                for (var i = 0; i < champsLongueur; i++) {
                    if ($(champs[i]).closest('.accordion-style1').height() < ($(champs[i]).closest('.input-group').parent().height())) {
                        var hauteur = $(champs[i]).closest('.input-group').parent().height();
                        $(champs[i]).closest('.accordion-style1').find('.panel-body').height(hauteur);
                    }
                }
            }
        }


        // On scroll jusqu'au champs qui affiche la première erreur.
        // Nous sommes par défaut dans le contexte du wizard. Dans d'autres cas, il faudra les gérer ici.
        //if (champs.length > 0) {
        if (typeof (modeSave) == 'undefined' || modeSave == ModeSave.WIZARD) {
            var $cibleErreur = $('#modal-wizard-evenement').find('.form-border-alert-danger:first');

            // DM: il est arrivé un cas ou le champ se nommait "qualiteComplexiteXBatiment.qualiteComplexite"
            if ($cibleErreur.length > 0) {
                // var conteneurOffset = Math.abs($('#modal-step-contents > .active .contenu-principal').offset().top, 10);
                var scrollToErreur = $cibleErreur.offset().top - WIZARD_ENTETE.taille; //+ conteneurOffset;
                $('#modal-step-contents').slimScroll({scrollTo: scrollToErreur, animate: true});
            }
        }
        //}
    },


    /**
     * Fonction d'affichage des erreurs au-dessus des champs dans les formulaires
     * @param {object} form.
     * @param {object} champ.
     * @param {list} texte.
     * @param {string} type.
     * @param {int} noErreur.
     * @param {boolean} aucunChamp.
     */
    afficherErreurChampsFiche: function (form, champs, texteErreur, type, noErreur, aucunChamp, messageTrouve) {
        var bordureAlerte = 'erreur-validation-border-danger';
        var niveauAlerte = 'alert-danger';
        if (type === 'avertissements') {
            bordureAlerte = 'erreur-validation-border-warning';
            niveauAlerte = 'alert-warning';
        }
        if (!aucunChamp) {
            var messageNoErreur = '<div class="form alert erreur-validation align-right ' + niveauAlerte + ' in" title="' + texteErreur + '"><p>' + noErreur + '</p></div>';
            if (niveauAlerte == 'alert-danger') {
                champs.after(messageNoErreur).addClass(bordureAlerte);
            } else {
                champs.before(messageNoErreur).addClass(bordureAlerte);
            }
        }

        if (!messageTrouve) {
            // pour les champs d'un bloc/sous-bloc d'une fiche, on affiche le message à la fin du bloc
            var formBlocContainer;
            if (form.is('.blocForm')) {
                formBlocContainer = form.find('.bloc-container').children();
            } else {
                formBlocContainer = form.closest('.bloc-container').children();
            }
            var formChildrenMessages = formBlocContainer.filter('div.form.alert.' + niveauAlerte);

            var attributNoErreur = aucunChamp ? '' : noErreur;
            var messageTexte = aucunChamp ? texteErreur : noErreur + '. ' + texteErreur;
            var message = '<div class="form alert align-left ' + niveauAlerte + ' in" no-erreur="' + attributNoErreur + '"><p>' + messageTexte + '</p></div>';

            // trouver les messages qui n'ont pas de numéro
            var formMessagesNoErreur = formChildrenMessages.filter('[no-erreur=""]');
            if (aucunChamp || formMessagesNoErreur.length === 0) {
                // si c'est une erreur, il faut qu'elle soit avant les avertissements
                var formMessagesAvertissement = formBlocContainer.filter('div.form.alert.alert-warning');
                if (niveauAlerte == 'alert-danger' && formMessagesAvertissement.length > 0) {
                    formMessagesAvertissement.first().before(message);
                } else {
                    formBlocContainer.last().after(message);
                }
            } else {
                formMessagesNoErreur.first().before(message);
            }
        }
    },


    /**
     * Fonction d'affichage des erreurs générales ou toute autre exception qui n'est pas une erreur spécifique à un champ donné.
     * @param {string} element à affecter.
     * @param {string} methode : append, prepend, before, after.
     */
    afficherErreurGenerique: function (element, methode, xhr, thrownError, duplicata) {
        if (!$(element).is('.afficher-erreur, .div-table-contenu, .champs-multiple, .blocForm, .garder-warning, .filtres')) {
            $(element).empty();
        } else if ($(element).is('.filtres')) {
            $(element).find('div.messages-erreurs').remove();
        }
        var erreurs;
        if (xhr != '') {
            var messageReduit = xhr.responseText.substr(0, xhr.responseText.indexOf('DETAIL'));
            var messageReduitInfos = xhr.responseText.substr(0, xhr.responseText.indexOf('\n\n'));
            erreurs = erreursAjax.formaterMessageErreur('', xhr, '', thrownError) + ' : ' + messageReduit + (messageReduitInfos ? '<br>' + messageReduitInfos : '') + (thrownError ? ' ' + thrownError : "");
        } else {
            erreurs = thrownError;
        }
        var niveauAlerte = $(element).is('.type-warning') ? 'alert-warning' : 'alert-danger';
        var classeMessagesErreurs = $(element).is('.garder-warning') ? '' : ' messages-erreurs';
        var duplicataAttribut = duplicata != undefined ? ' ' + duplicata : '';
        var message = '<div class="alert ' + niveauAlerte + classeMessagesErreurs + '"' + duplicataAttribut + '>' + erreurs + '</div>';
        var selecteur = $(element);
        if (methode === 'append') {
            if (!$(element).is('.filtres')) {
                selecteur.append(message);
            } else {
                message = message.replace(/\[[^}]*] /g, '');
                selecteur.append(message);
            }
        } else if (methode === 'prepend') {
            selecteur.prepend(message);
        } else if (methode === 'before') {
            selecteur.before(message);
        } else if (methode === 'after') {
            selecteur.after(message);
        }
        // Il faut afficher l'erreur quand on envoit au bas de la fenêtre.
        // if($('.slimScrollDiv')) {
        //       scroll.positionCurseurScroll('.messages-erreurs', '#modal-step-contents');
        //   }
    },


    /**
     * Fonction de reset des erreurs
     * @param {string} champ.
     * @param {string} erreur.
     */
    effacerErreurChamps: function (form, duplicata) {
        form.find('.form-control')
            .removeClass('form-border-alert-danger')
            .removeClass('erreur-validation-border-warning')
            .removeClass('erreur-validation-border-danger');
        form.find('.select2-container .select2-choice').css({'border': '1px solid #aaa'});

        var exceptionGarderWarning = [];
        if (!form.hasClass('garder-warning')) {
            exceptionGarderWarning = $('.garder-warning').parent().find('.alert.alert-warning');
        } else {
            if (duplicata != undefined) {
                $('.wiz-validation-warning').find('.alert.alert-warning[' + duplicata + ']').remove();
            }
        }
        form.find('.form.alert').not(exceptionGarderWarning).remove();
        $('.messages-erreurs').not(exceptionGarderWarning).remove();

    },


    /**
     * Fonction de formatage des messages d'erreurs
     * @param {event} event.
     * @param {object} jqXHR - XMLHttpRequest.
     * @param {oject} ajaxSettings - Type d'erreur et un oject (Exception object).
     * @param {string} thrownError  - Portion textuelle du statut HTTP.
     * @return {string} Message d'erreur (avec sous sans formatage)
     *
     */
    formaterMessageErreur: function (event, jqXHR, ajaxSettings, thrownError) {
        if (jqXHR.status === 0) {
            return ('Non connecté.\nVérifiez votre connexion réseau');
        } else if (jqXHR.status == 400) {
            //return ('Mauvaise requête. [400]');
            return ('Attention'); // Ces erreurs proviennent de la validation normale et seront donc affichées à l'utilisteur. On rend donc le message plus friendly
        } else if (jqXHR.status == 401) {
            return ('Non autorisé. [401]');
        } else if (jqXHR.status == 403) {
            return ('Interdit. [403]');
        } else if (jqXHR.status == 404) {
            return ('Non trouvé. [404]');
        } else if (jqXHR.status == 408) {
            return ('Requête hors-délai. [408]');
        } else if (jqXHR.status == 409) {
            return ('Conflit. [409]');
        } else if (jqXHR.status == 500) {
            return ('Erreur interne du serveur [500]');
        } else if (jqXHR.status == 503) {
            return ('Service indisponible. [503]');
        } else if (jqXHR.status == 511) {
            return ('Authentification requise. [511]');
        } else if (thrownError === 'parsererror') {
            return ('Erreur d\'analyse du JSON');
        } else if (thrownError === 'timeout') {
            return ('Délai dépassé.');
        } else if (thrownError === 'abort') {
            return ('Requête Ajax abandonnée');
        } else {
            return ('Erreur ' + jqXHR.status + '\n' + jqXHR.responseText);
        }
    }

}; // namespace erreursAjax


var nomodal = 0; // sert à associer chaque popup modal au bon background noir, afin de fermer le bon a la fin

// Espace de nom réservé à l'interaction avec les fenêtres modal (global)
var fenetreModal = {

    /**
     * Fonction de correspondance de la hauteur du modal et de sa classe correspondante.
     * @param {string} idModal - Nom du modal
     */
    clique: function (idModal) {

        /**
         * Fonction d'interception de fermeture du modal. Utilisé pour lancer différentes actions, validations ou interactions avec les utilisateurs de geocentralis
         */

        $('#' + idModal).on('click', '[data-dismiss="modal-fermer"]', function () {
            fenetreModal.fermerModal(idModal);
        });
    },

    escape: function (idModal) {
        $('#' + idModal).on('keydown', function (e) {
            if (e.keyCode == 27) {
                fenetreModal.fermerModal(idModal);
            }
        });
    },


    fermerModalAlerteDivs: function (idModal, nomodal) {
        if (nomodal === undefined) nomodal = false;
        // cas special générique en fait
        if (nomodal) {
            $('[nomodal="' + nomodal + '"]').remove();
            return;
        }
        var objPopup;
        var objBackground;
        if (idModal) {
            objPopup = $('#' + idModal);
            objBackground = $('#modal-message-background');
        } else {
            objPopup = $('#modal-message-alerte');
            objBackground = $('#modal-message-background[nomodal=' + objPopup.attr('nomodal') + ']');
        }

        objPopup.remove();
        objPopup.data('modal', null);
        objBackground.remove();
        $('#modal-message-alerte-footer').remove();
        objBackground.data('modal', null);
        $('#modal-message-alerte-footer').data('modal', null);
    },


    /**
     * Fonction de fermeture du modal.
     * @param {Object|string} idModal - Objet Jquery de la modal ou le selecteur jquery
     */
    fermerModal: function (modalOridModal) {
        var modal_container = $(".modal-open").first();

        destroyDataTableInContainer(".modal-dialog");
        var modal = modalOridModal;
        if(typeof(modalOridModal)=="string"){
            modal = $('#' + modalOridModal);
        }

        $(modal).modal('hide');

        // #14691
        if ($(modal).attr('stop-le-spinner-on-close')) {
            wait.stop();
        }
        if (!($(modal).find('.modal-dialog').attr('ne-pas-detruire'))) {
            if (($(modal).find('.modal-dialog').attr('remettre-modal-open'))) {
                $('body').addClass('modal-open');
            }
            $(modal).data('bs.modal', null);
            $(modal).remove();

            var idxModal = ($('.modal:visible').length); // raise backdrop after animation.
            if (idxModal > 1) {
                $('.modal-backdrop').is('.stacked').css('z-index', (9000 + (10 * idxModal)) - 1);
            } else if (idxModal === 1) {
                $('.modal-backdrop').css('z-index', 1039);
            } else if (idxModal === 0) {
                $('.modal-backdrop').remove();
            }
        } else {
            $('.modal-backdrop').hide();
        }

        /* #21837 - patch bug bootstrap 3.7 */
        setTimeout(function () {
            if (modal_container.length) {
                var modal_container_padding = modal_container.css("padding-right");
                if (modal_container_padding.length && modal_container_padding.indexOf("px") != -1) {
                    var modal_container_new_padding = parseInt(modal_container_padding) - 17;
                    if (modal_container_new_padding < 0) modal_container_new_padding = 0;
                    modal_container.css("padding-right", modal_container_new_padding + "px");
                }
            }
        }, 0);
    },


    /**
     * Fonction de sélection d'actions de contrôle de la fermeture du modal.
     * @param {object} message - Paramètres de création de la fenêtre du message inline du modal.
     * @param {string} contenant - Contenant sur lequel appliquer le nouveau modal (messages).
     */
    modalMessage: function (message) {
        // taille du modal :
        var taille = '';
        if (message.taille == "petite") {
            taille = 'modal-sm';
        } else if (message.taille == "grande") {
            taille = 'modal-lg';
        } else if (message.taille == "immense") {
            taille = 'modal-alerte-immense';
        } else {
            taille = '';
        }
        var arrierePlan;
        var attache;
        if (typeof (message.conteneur) !== 'undefined') {
            arrierePlan = 'body';
            attache = message.conteneur;
        } else {
            if ($('#wizard').length > 0) {
                arrierePlan = '#modal-wizard-evenement ' + (message.classe === "modal-dialog" ? message.classe : ".modal-content ");
                attache = '#wizard';
            } else {
                arrierePlan = $('#main-container').length > 0 ? '.main-container': '.modal-content';
                attache = 'body';
            }
        }

        nomodal++;
        // modale_selecteur qui nous permets d'éviter d'avoir des conflits de modales... grace a nomodal
        // Pour ne pas à avoir refact tout le code; je viens corriger les cas les plus simples de modalMessage
        // qui s'autosuffira (pour le contenu et le background, et son code autocontenu)
        var modale_selecteur = 'nomodal="' + nomodal + '"';
        $(arrierePlan).prepend('<div id="modal-message-background"  class="modal-message-background" ' + modale_selecteur + '></div>');
        $(attache).prepend('<div id="modal-message-alerte" class="modal-message-alerte modal-message-ombre ' + (message.classe === "modal-dialog" ? message.classe : "modal-content") + ' ' + taille + '" tabindex="-1" ' + modale_selecteur + '"></div>'); // tabindex = -1 est utilisé pour que le ESC fonctionne
        var jq_modale_selecteur = $('.modal-message-alerte[' + modale_selecteur + ']');

        var headers = '<div class="modal-header">' +
            (typeof (message.sansX) !== 'undefined' && message.sansX === true ? '' : '<button type="button" class="close" data-dismiss="modal-fermer" aria-label="Close"><span aria-hidden="true">&times;</span></button>') +
            '<h4 class="modal-title text-center">' + (typeof (message.enteteTitre) !== 'undefined' ? message.enteteTitre : 'Message') + '</h4></div>';

        var texte = '';
        if (typeof (message['texteExplicatif']) === 'undefined') {
            texte = "";
        } else {
            if (message['texteExplicatif'].length > 0) {
                if ('texteExplicatifIcone' in message) {
                    texte = '<div class="row"><div class="col-sm-1 col-sm-offset-1 margin-bottom-1 margin-top-1"><i class="fa ' + message['texteExplicatifIcone'] + ' fa-3x"></i></div><div class="col-sm-10 margin-bottom-1 margin-top-1 align-left">' + message['texteExplicatif'] + '</div></div>';
                } else {
                    texte = '<br><p class="">' + message['texteExplicatif'] + '</p><br>';
                }
            } else {
                texte = "";
            }
        }
        var contenu = '<div id="modal-message-alerte-contenu" ' + modale_selecteur + ' class="text-center modal-body">' + '<h4 class="modal-title">' + (typeof (message['titre']) !== 'undefined' ? message['titre'] : '') + '</h4>' + texte;
        (typeof (message.contenuFormulaire) !== 'undefined' && message.contenuFormulaire !== '' ? contenu = contenu + '<div id="modal-message-alerte-formulaire">' + message['contenuFormulaire'] + '</div>' : '');
        if (typeof (message.vueACharger) !== 'undefined' && message.vueACharger !== '') {
            wait.start();
            var params = message.vueAChargerParams ? message.vueAChargerParams : '';
            var jqxhr = $.ajax({
                    url: message.vueACharger,
                    dataType: 'html',
                    // avec async = true, on affiche le modal et le spinner. Ensuite, on ajoute le contenu quand
                    // il est prêt. Sinon, le spinner ne s'affiche pas du tout mais je ne sais pas pourquoi.
                    async: message.async ? message.async : false,
                    data: params
                }
            );

            jqxhr
                .done(function (response) {
                    var contenuVue = response;
                    contenu = contenu + contenuVue;

                    if (message.async) {
                        $('[id="modal-message-alerte-contenu"][' + modale_selecteur + ']').append(contenuVue);
                        if (message.init) {
                            message.init();
                        }
                    }
                    wait.stop();
                });

            jqxhr
                .fail(function (xhr, textStatus, errorThrown) {
                    infos.ajouterMessageToast({
                        message: "Erreur de chargement de la page : <br> " + erreursAjax.formaterMessageErreur('', xhr, '', errorThrown),
                        messageDuree: 12000,
                        messageCouleur: "red"
                    });
                    wait.stop();
                });
            jqxhr.complete(function (jqXHR, textStatus) {
                wait.stop();
            });
        }
        contenu = contenu + '</div>';
        var boutons = "";
        if (typeof (message.boutons) === 'undefined') {
            message.boutons = {
                'Ok': {
                    label: " Ok ",
                    class: "btn",
                    id: "alerte-modal-annuler",
                    action: function () {
                    }
                }
            };
        }
        var messageBoutons = message.boutons;
        for (var i in message.boutons) {
            var objet = (typeof (messageBoutons[i]['objet']) != "undefined" ? 'objet="' + messageBoutons[i]['objet'] + '"' : '');
            var municipalite = (typeof (messageBoutons[i]['municipalite']) != "undefined" ? 'municipalite="' + messageBoutons[i]['municipalite'] + '"' : '');
            var icone;
            if (messageBoutons[i]['icone']) {
                icone = ' <i class="ace-icon fa ' + messageBoutons[i]['icone'] + '"></i>';
            } else {
                icone = messageBoutons[i]['type'] == "delete" ? ' <i class="ace-icon fa fa-trash-o"></i>' : messageBoutons[i]['type'] == "save" ? ' <i class="ace-icon fa fa-hdd-o"></i>' : messageBoutons[i]['type'] == "print" ? ' <i class="ace-icon fa fa-print-o"></i>' : '';
            }

            boutons += '<button id="' + messageBoutons[i]['id'] + '"' + objet + ' ' + municipalite + ' data-action="' + '" class=" ' + messageBoutons[i]['class'] + ' ' + messageBoutons[i]['classSupp'] + ' btn-sm" data-type="' + messageBoutons[i]['type'] + '"> ' + icone + messageBoutons[i].label + ' </button> ';
        }
        var footer = '<div class="modal-footer">' + boutons + '</div></div>';
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            /* on ne veut pas le draggable sur mobile car ça entre en conflit avec le touch event */
            $(jq_modale_selecteur).append(headers + contenu + footer).hide().fadeIn('fast');
        } else {
            $(jq_modale_selecteur).append(headers + contenu + footer).draggable().hide().fadeIn('fast');
        }
        var centre = $('.modal-message-background[' + modale_selecteur + ']').innerWidth() / 2 - $('.modal-message-alerte[' + modale_selecteur + ']').innerWidth() / 2;
        $(jq_modale_selecteur).css({'left': centre});
        if (message.zIndex) {
            $(jq_modale_selecteur).css({'z-index': message.zIndex});
        }
        // mettre le focus sur le modal pour que le ESC fonctionne
        $(jq_modale_selecteur).focus();

        var buttons = $(jq_modale_selecteur).find('button[data-action]');
        var idx = 0;
        $.each(message.boutons, function (name, obj) {
            buttons.eq(idx++).click(function (e) {
                obj.action(e);
                if (!e.isDefaultPrevented()) {
                    fenetreModal.fermerModalAlerteDivs(false, nomodal);
                }
                return false;
            });
        });

        $(jq_modale_selecteur).keyup(function (e) {
            if (e.keyCode === 27) { // touche escape
                $(jq_modale_selecteur).find('[data-dismiss="modal-fermer"]').click();
            }
        });
        $(jq_modale_selecteur).on('click', '[data-dismiss="modal-fermer"]', function () {
            if (typeof (message.callback_on_escape) !== 'undefined') {
                message.callback_on_escape();
            }
            fenetreModal.fermerModalAlerteDivs(false, nomodal);
        });
        // #12701 : éviter double appel de init
        // Seulement celui du xhr.done sera appelé
        if (typeof (message['vueACharger']) == 'undefined' && !message.async) {
            if (message.init) {
                message.init();
            }
        }
    },


    /**
     * Fonction de correspondance de la hauteur du modal et de sa classe correspondante.
     * @param {selecteur jQuery} modal - Selecteur jQuery du modal.
     * @param {string} div - Nom du div auquel ajuster la taille. Par défaut, on ajuste la taille du contenu des étapes du wizard. Il faut préciser #div ou .div car ce peut être un id ou une classe.
     */
    calculerHauteurModal: function (modal, div) {
        //On vérifie aussi si la hauteur du modal est égale à la hauteur du contenu de la fenêtre : dans ce cas, on redimentionne le modal.
        if ((modal.find('.modal-dialog').height() < modal.find(".modal-content").height()) || ($(window).height() <= (modal.find(".modal-content").height() + modal.find(".modal-header").height() + modal.find(".modal-footer").height()))) {
            // var hauteurModal = modal.find(".modal-content").innerHeight();
            var hauteurHeader = $(modal).attr('id') === 'modal-camera' ? 0 : modal.find(".modal-header").innerHeight();
            var hauteurFooter = modal.find(".modal-footer").innerHeight();
            var hauteurNouvelleModal = $(modal).attr('id') === 'modal-camera' ? $(window).height() : $(window).height() * 0.91;

            modal.find(".modal-body").innerHeight(hauteurNouvelleModal - hauteurHeader - hauteurFooter);
            if ($(div).innerHeight() > modal.find(".modal-body").innerHeight()) {
                $(div).height(modal.find(".modal-body").height());
            }
            scroll.ajouterSlimScroll((typeof (div) === 'undefined' ? '#modal-step-contents' : div), {
                hauteur: modal.find(".modal-body").height(),
                largeur: 10
            });
        }
    },


    /**
     * Fonction de correspondance de la largeur du modal et de sa classe correspondante.
     * @param {string} nom - Largeur du modal pour l'utilisateur.
     */
    tailleModal: function
        (nom) {
        var taille;
        if (nom === "petite") {
            taille = "modal-sm";
        } else if (nom === "normale") {
            taille = "modal-nm";
        } else if (nom === "grande") {
            taille = "modal-lg";
        } else if (nom === "tres-grand") {
            taille = "modal-tg";
        } else if (nom === "immense") {
            taille = 'modal-xxx';
        } else if (nom == "reperes") {
            taille = 'modal-reperes';
        }
        return taille;
    },


    /**
     * Fonction de redimentionnement du modal si une étape ou l'étape courante est plus grande ou plus petite que la fenêtre actuelle du Modal
     * @param {string} id - id du modal à redimensionner.
     * @param {string} tailleModal - taille courante de la modal
     * @param {string} tailleEtape - taille voulu pour la modal
     * @param {string} callbacks - Liste de fonctions à exécuter suite au redimentionnement.
     */
    redimentionnerModal: function (idModal, tailleModal, tailleEtape, callbacks) {
        if (tailleModal != tailleEtape && typeof (tailleEtape) != "undefined") {
            var tailleModalClasse = fenetreModal.tailleModal(tailleModal);
            var tailleEtapeClasse = fenetreModal.tailleModal(tailleEtape);
            var selecteur = '#' + idModal;
            if (tailleEtape === "normale" || tailleEtape === "petite") {
                $(selecteur).find('.modal-dialog').addClass(tailleEtapeClasse, 250);
                $(selecteur).find('.modal-dialog').removeClass(tailleModalClasse, 250);
            } else {
                $(selecteur).find('.modal-dialog').addClass(tailleEtapeClasse, 250);
                $(selecteur).find('.modal-dialog').removeClass(tailleModalClasse, 250);
            }
        }
        if (typeof (callbacks) != 'undefined') {
            for (var i = 0; i < callbacks.length; i++) { // On exécuter une série de callbacks pour qui la fenêtre de modal est nécessaire.
                callbacks[i]();
            }
        }
    },

    /**
     * Créer une fenêtre Modal.
     * @param {object} variableModal - variable qui contient les paramètres de création du Modal.
     * @param {object} Paramètres supplémentaires
     * @param {array } callbacks
     */
    creerModal: function (variableModal, customParams, callbacks, bool_post) {
        bool_post = bool_post ? bool_post : false;
        var id_modal = '#' + variableModal.id;
        wait.start();
        $('.modal-backdrop').remove();

        $(id_modal).remove();

        var contenu = '<div id="' + variableModal.id + '" class="modal"></div>';
        $('body').prepend(contenu);

        var m = $(id_modal);
        m.modal({
            backdrop: 'static',
            show: true,
            keyboard: false
        });

        fenetreModal.clique(variableModal.id);
        fenetreModal.escape(variableModal.id);
        var loadParams = {};
        delete variableModal._modal;
        loadParams.json = JSON.stringify(variableModal);
        variableModal._modal = m;
        var view = variableModal.view;
        //  On doit ajuster le z-index si on a plusieurs modals qui se superposent. Sinon, le dernier modal ajouté s'insère AVANT le modal précédent dans le HTML et on ne voit que le précédent, le suivant étant masqué par le précédent.
        var idxModal = ($('.modal:visible').length);
        if (idxModal >= 1 && $('.modal-backdrop:first').is('.stacked')) {
            $('.modal-backdrop:first').not('.stacked').addClass('stacked');
        }
        var modal_zindex = 9000 + (10 * idxModal);
        m.css('z-index', modal_zindex);

        m.load(view, loadParams, function () { // Callback
            if (variableModal.cacherAuChargement !== undefined) {
                if (variableModal.cacherAuChargement === true) {
                    m.modal('hide');
                }
            }

            $('.modal-backdrop').not('.stacked').css('z-index', modal_zindex - 1);
            var divContenu = 'contenu';
            var divContenuSelecteur = '#' + divContenu;

            if (variableModal.template_view) { // On charge le contenu de la vue
                var vue = variableModal.template_view;
                var url = vue;  // pourquoi

                if (customParams.id) {
                    loadParams.id = customParams.id;
                }

                if (customParams.liste_batiments) {
                    loadParams.liste_batiments = customParams.liste_batiments;
                }

                if (customParams.liste_date_evenement) {
                    loadParams.liste_date_evenement = customParams.liste_date_evenement;
                }

                if (customParams.readOnly) {
                    loadParams.readOnly = customParams.readOnly;
                }

                if (customParams.read_only) {
                    loadParams.read_only = customParams.read_only;
                }

                if (customParams.evenements) {
                    loadParams.evenements = customParams.evenements;
                }

                // TODO: vérifier si c'est toujours utile en fin de cycle de dev du feature
                if (customParams.id_municipalite) {
                    loadParams.id_municipalite = customParams.id_municipalite;
                }

                if (customParams.id_role_evaluation) {
                    loadParams.id_role_evaluation = customParams.id_role_evaluation;
                }
                if (customParams.id_accordeon) {
                    loadParams.id_accordeon = customParams.id_accordeon;
                }
                if (customParams.ue_selectionne) {
                    loadParams.ue_selectionne = customParams.ue_selectionne;
                }
                if (customParams.id_module) {
                    loadParams.id_module = customParams.id_module;
                }
                if (customParams.rapport_id) {
                    loadParams.rapport_id = customParams.rapport_id;
                    loadParams.id_type_evenement = customParams.id_evenement_type;
                }
                // option pour combiner loadParams et les params originaux de customParams
                if (variableModal.fournir_customParams_au_template_view) {
                    loadParams = Object.assign({}, loadParams, customParams);
                }

                const success_cb = function (responseText, textStatus, jqXHR) {
                    init_date_picker($(divContenuSelecteur));
                    $('.modal-dialog').css('display', 'block');

                    setTimeout(function () {
                        fenetreModal.calculerHauteurModal(m, divContenuSelecteur);
                    }, 250);

                    if (variableModal.callback) {
                        if (customParams.rapport_id) {
                            variableModal.callback(customParams.rapport_id, customParams.id_evenement_type);
                        } else if (variableModal.fournir_variableModal_au_callback) {
                            variableModal.customParams = customParams;
                            variableModal.callback(variableModal);
                        } else {
                            variableModal.callback();
                        }
                    }
                    init_date_picker();
                    if (typeof (callbacks) != 'undefined') {
                        for (var i = 0; i < callbacks.length; i++) { // On exécuter une série de callbacks pour qui la fenêtre de modal est nécessaire.
                            callbacks[i]();
                        }
                    }
                };
                if (bool_post){
                    const sub_success_sb = function(responseText, textStatus, jqXHR) {
                      $(divContenuSelecteur).find('.modal-body').html(responseText);
                      success_cb(responseText, textStatus, jqXHR);
                    };
                    call_ajax(url, 'POST', loadParams, sub_success_sb);
                } else {
                    const params = $.param(loadParams)
                    $(divContenuSelecteur).find('.modal-body').load(`${url}?${params}`, '', success_cb);

                }

            } else if (variableModal.template) { // Chargement d'un template par exemple
                fenetreModal.calculerHauteurModal(m, divContenuSelecteur);
                if (variableModal.callback) {
                    variableModal.callback();
                }
                init_date_picker();
                if (typeof (callbacks) != 'undefined') {
                    for (var i = 0; i < callbacks.length; i++) {
                        callbacks[i]();
                    }
                }
            } else if (variableModal.contenuHTML) { // On charge le contenu statique
                var contenuHTML = variableModal.contenuHTML;
                if ('contenuIcone' in variableModal) {

                    contenuHTML = '<div class="row">\n' +
                        '    <div class="col-sm-1 col-sm-offset-1 margin-bottom-1 margin-top-1"><i class="fa ' + variableModal.contenuIcone + ' fa-3x"></i>\n' +
                        '    </div>\n' +
                        '    <div class="col-sm-10 margin-bottom-1 margin-top-15 align-left">\n' +
                        '    ' + variableModal.contenuHTML +
                        '    </div>\n' +
                        '</div>';
                }
                $(divContenuSelecteur).html(contenuHTML);
                if (variableModal.callback) {
                    variableModal.callback();
                }

            } else {
                if (variableModal.callback) {
                    variableModal.callback();
                }
            }
        });
        m.on('hide.bs.modal', function () {
            $('body').removeClass('modal-open');
        });
        bootstrapOn.initTooltips();

        wait.stop();
    }
}; // namespace fenetreModal

// Espace de nom réservé à l'utilisation des Regex (global)
var regEx = {

    /**
     * Fonction d'extraction des informations du chemin à l'intérieur d'une chaîne de caractères préformattée.
     * @param {string} element - La chaîne de caractères à traiter : municipalite-id_municipalite-3.
     * @param {string} separateur - Caractère à utiliser pour la séparation : '-' pour créer le ID du bouton ou '%' pour déconstruire le ID de l'élément.
     */
    decomposeIdFiltre: function (element, separateur) {

        var resultat;
        var filtre = element;

        // var colonne = /.+?(?=-)/.exec(filtre)[0];
        // var champ = /\-(.*?)\-/.exec(filtre)[1];
        // var id = /[^-]*$/.exec(filtre)[0];

        var separateurColonne = new RegExp(".+?(?=" + separateur + ")");
        var colonne = (separateurColonne.exec(filtre) === null ? filtre : separateurColonne.exec(filtre)[0]);
        // var colonne = separateurColonne.exec(filtre)[0];
        var separateurChamp = new RegExp("\\" + separateur + "(.*?)\\" + separateur); // \ : caractère d'échappement
        var champ = separateurChamp.exec(filtre)[1];
        var separateurId = new RegExp("(?:.*?" + separateur + "){2}(.*)");

        var id = separateurId.exec(filtre)[1];
        return resultat = [colonne, champ, id];
    },

    /**
     * Fonction d'extraction des informations du nom d'un select (jQuery) où on trouve : nom (id) dans le texte.
     * @param {string} element - La chaîne de caractères à traiter : Lévis (123456).
     */
    decomposeNomSelectFiltre: function (titre) {
        var resultat = /\([\d]+/.exec(titre);
        if (resultat != null) {
            resultat = titre.substring(0, resultat.index).trim();
        } else {
            resultat = titre;
        }

        return resultat;
    },


    /**
     * Fonction d'extraction de deux dates dans un range.
     * @param {string} element - La chaîne de caractères à traiter : 2015-04-02-2015-06-04.
     */
    decomposeDateRange: function (element) {

        var resultat;
        var filtre = element;

        var debut = /.+?(?= - )/.exec(filtre)[0];
        var fin = /[^ - ]*$/.exec(filtre)[0];

        return resultat = [debut, fin];
    }

}; // namespace tenueAJourBoutons


// Espace de nom réservé aux fonctions de scroll
var scroll = {

    /**
     * Positionnement du curseur et de l'élément au centre de l'écran suite à un append à l'intérieur d'un slimScroll.
     * @param {string} element - élément sur lequel le append est effectué.
     * @param {string} cadreSlimScroll - Div sur lequel est appliqué le slimScroll.
     */
    positionCurseurScroll: function (element, cadreSlimScroll) {
        $(cadreSlimScroll).slimScroll({scrollTo: '0px'});
        var hauteur = 0;
        if ($(element).last().length > 0) {
            hauteur = $(element).last().height();
        }
        var hauteurCadre = $(cadreSlimScroll).offset().top;
        var emplacement = 0;
        if ($(element).last().length > 0) {
            emplacement = $(element).last().offset().top;
        }
        var calculPosition = emplacement - (hauteur + (hauteurCadre * 2));
        $(cadreSlimScroll).slimScroll({scrollTo: calculPosition, animate: true});
    },


    /**
     * Fonction d'ajout d'un slimScroll à un Div. But : centraliser et contrôler l'apparence pour toute l'application.
     * @param {string} id du div auquel on ajoute le slimScroll
     * @param {number} hauteur de la fenêtre de scroll (body). Optionnel.
     * @param {number} largeur du scroll. Optionnel.
     */
    ajouterSlimScroll: function (div, opt) {
        var hauteurScroll;
        var largeurScroll;
        if (typeof (opt.hauteur) === "undefined" || opt.hauteur === "") {
            if (div === "#modal-step-contents") {
                hauteurScroll = $(".modal-body").height() + 'px';
            } else if (div === "#div-resultat") {
                var hauteurModal = $(".modal-content").innerHeight();
                var hauteurNouvelleModal = $(window).height() * 0.91;
                hauteurScroll = hauteurNouvelleModal - hauteurModal;
            } else {
                hauteurScroll = $(div).height() + 'px';
            }
        } else {
            hauteurScroll = opt.hauteur + 'px';
        }

        if (typeof (opt.largeur) === "undefined") {
            largeurScroll = '10px';
        } else {
            largeurScroll = opt.largeur + 'px';
        }
        var options = {
            disableFadeOut: true,
            height: hauteurScroll,
            distance: '1px',
            railVisible: true,
            alwaysVisible: true,
            railOpacity: 0.1,
            size: largeurScroll
        };
        $.each(opt, function (index, value) {
            if (index !== "hauteur" && index !== "largeur") {
                options[index] = value;
            }
        });
        $(div).slimScroll(options);
    }

}; // namespace scroll


// Espace de nom réservé aux fonction de csrf, etc
var securite = {

    /**
     * Fonction de validation pour vérifier si l'usager de la donnée à valider, par exemple, l'usager assigné dans la table des évènements est le même que l'usager de la session.
     * @desc Pour des raisons de sécurité, on ne laisse pas des informations sur la session ou l'usager dans le javascript. Appel Ajax unique et on valide par true/false si l'usager est le même à chaque fois que cela est requis.
     * @param {number} user - id de l'usager assigné ou autorisé en provenance d'une ligne de la BD ou d'un quelconque enregistrement.
     * @return {bool} True or False à la question "Est-ce le même ?".
     */
    estMemeUsagerQueSession: function (usager) {
        var idEvenement = $('#wizard').attr('id-evenement');
        var url = '/gestion-roles/tenue-a-jour/valider-usager/' + usager + '/';
        var reponse = {};
        var params = {'id_evenement': idEvenement};
        var data = tenueAJourModal.nettoyerParams(params);

        var jqxhr = $.ajax({
                url: url,
                type: 'GET',
                data: data,
                async: false
            }
        );

        jqxhr
            .done(function (response) {
                reponse = JSON.parse(response);
            });
        jqxhr
            .fail(function (xhr, textStatus, errorThrown) {
                infos.ajouterMessageToast({
                    message: "Erreur de validation de l'usager : <br> " + erreursAjax.formaterMessageErreur('', xhr, '', errorThrown),
                    messageCouleur: "red"
                });
            });
        return reponse;
    },

    /**
     * Fonction getter de la propriété du cookie
     * @return Le token CSRF
     */
    reqCSRFToken: function () {
        var csrfTokenValeur = securite.reqCookie($('#csrf_cookie_name').val());
        return csrfTokenValeur;
    },


    reqOrganisation: function () {
        var idEvenement = $('#wizard').attr('id-evenement');
        var url = '/gestion-roles/tenue-a-jour/valider-organisation/';
        var reponse = {};
        var params = {'id_evenement': idEvenement};
        var data = tenueAJourModal.nettoyerParams(params);

        var jqxhr = $.ajax({
                url: url,
                type: 'GET',
                data: data,
                async: false
            }
        );

        jqxhr
            .done(function (response) {
                reponse = JSON.parse(response);
            });
        jqxhr
            .fail(function () {
            });
        return reponse;

    },



    /**
     * Fonction d'extraction d'information d'un cookie. À utiliser principalement pour récupérer le CSRF token du cookie.
     * @param {string} name - le nom relatif à CSRF_COOKIE_NAME afin de trouver la valeur pour csrftoken.
     * @return La valeur de la propriété du cookie
     */
    reqCookie: function (name) {
        var cookieValue = null;
        if (document.cookie && document.cookie != '') {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = jQuery.trim(cookies[i]);
                // Does this cookie string begin with the name we want?
                if (cookie.substring(0, name.length + 1) == (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    },


    /**
     * Fonction de protection du CSRF token pour empêcher l'envoi à d'autres domaines : voir settings.crossDomain dans jQuery 1.5.1 et plus.
     * @param {string} method - settings.type : pour le crossDomain.
     */
    csrfSafeMethod: function (method) {
        // these HTTP methods do not require CSRF protection
        return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
    }

}; // namespace securityHelpers

// Espace de nom réservé aux fonctions de "processing info..."
var wait = {

    /**
     * Fonction de traitement dynamique du temps d'attente (loading data).
     * @param {bool} processing - 0 si on veut terminer l'appel, et 1 si on veut maintenir l'attente pour le chargement en cours.
     */
    processing: function (processing, divContenu, couleurFond, transparence) {
        var spinDestination = (divContenu ? '#spin-' + divContenu : '#spin');
        if (processing) {
            if ($(spinDestination).length == 0) {
                wait.start(divContenu, couleurFond, transparence);
            }
        } else {
            wait.stop(divContenu);
            if (typeof (table) != 'undefined') {
                if ('sans_processing' in table.settings) {
                    table.settings.sans_processing = false;
                }
            }
        }
    },


    /**
     * Fonction de démarrage pour l'information sur l'état du chargement en cours.
     * @param {string} div - le div sur lequel assigner le spin.js (dans le cas où un spin ne prend pas tout l'écran mais
     * est localisé.
     * @param {string} couleurFond - un string de la valeur rgb à utliser pour le fond d'écran ex : 0,0,0
     * @param {number} transparence - la valeur de la transparence à utiliser si l'option par défaut ne suffit pas.

     */
    start: function (div, couleurFond, transparence, petit) {
        if (wait_is_active) {
            return;
        }
        var cible = (div ? '#' + div : '#spinorama');
        var spinCible = '';
        var destination = '';
        if (typeof (petit) != 'undefined') {
            if (petit === 1) {
                spinCible = cible + '-' + 'petit';
                var spinCibleTemp = spinCible;
                $(cible).append('<div id="' + spinCibleTemp.replace(/#/g, '') + '" style="{position: relative}"></div>');
                destination = $(spinCible);
                spinnerSmall.spin(destination.get(0));
            }
        } else {
            spinCible = cible;
            destination = $(spinCible);
            spinner.spin(destination.get(0));
        }

        var couleur = (couleurFond ? couleurFond : "0, 0, 0");
        var opacite = (transparence ? transparence : ".25");
        var fond = (couleur === "aucune" ? "" : 'background: rgba(' + couleur + ',' + opacite + ');');
        var spinCibleDiv = (div ? 'spin-' + div : 'spin');
        var zIndex = 101;
        if ($(cible).css('z-index') !== 'auto') {
            zIndex = $(cible).css('z-index') + 1;
        }
        var overlay = $('<div id="' + spinCibleDiv + '" class="overlay" style="position: absolute; ' + fond + ' z-index: ' + zIndex + ';"></div>');
        overlay.css({
            width: '100%',
            height: '100%',
            left: 0,
            top: 0
        });
        $(destination.get(0)).parent().css({'position': 'relative'});
        overlay.appendTo(destination);
        wait_is_active = true;
        if (div !== '') {
            if (($(cible).height() > $(window).height())) {
                $('.spinner').css('top', 150 + 'px');
            }
        }
    },


    /**
     * Fonction d'arrêt pour l'information sur l'état du chargement en cours.
     * @param {string} Div sur lequel un spin.js a été affecté.
     * @param {bool} False : On ferme volontairement le spinner.
     */
    stop: function (divContenu, garderSpin) {
        $('#pageSpinner').remove();
        spinner.stop();
        var spinDestination = (divContenu ? '#spin-' + divContenu : '#spin');


        $(spinDestination).fadeOut(400, function () {
            $(this).remove();
            $(document).find('.overlay').remove(); // Endroit où des overlays (mix startspinner et wait.start()) restent collés
        });
        wait_is_active = false;
    }
}; // namespace wait


function initAceThumbnails(colorbox) {
// Affichage de la photo dans un modal
    var $overflow = '';
    var colorbox_params = {
        rel: colorbox,
        reposition: true,
        scalePhotos: true,
        scrolling: false,
        previous: '<i class="ace-icon fa fa-arrow-left"></i>',
        next: '<i class="ace-icon fa fa-arrow-right"></i>',
        close: '&times;',
        current: 'Photos {current} de {total}',
        maxWidth: '100%',
        maxHeight: '100%',
        photo: true,
        onOpen: function () {
            $overflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
        },
        onClosed: function () {
            document.body.style.overflow = $overflow;
        },
        onComplete: function () {
            $.colorbox.resize();
            wait.stop();
            //$("#cboxClose").remove();
        }
    };

    if ($(`.ace-thumbnails .cboxElement[data-rel="${colorbox}"]`).closest('#exp-ue-table-batiment').length === 0) {
        $(`.ace-thumbnails .cboxElement[data-rel="${colorbox}"]`).colorbox(colorbox_params);
    }

    $("#cboxLoadingGraphic").append("<i class='ace-icon fa fa-spinner'></i>");//let's add a custom loading icon
}

function initCustomColorBox(item, colorbox) {
// Affichage de la photo dans un modal
    var $overflow = '';
    var colorbox_params = {
        rel: colorbox,
        reposition: true,
        scalePhotos: true,
        scrolling: false,
        previous: '<i class="ace-icon fa fa-arrow-left"></i>',
        next: '<i class="ace-icon fa fa-arrow-right"></i>',
        close: '&times;',
        current: 'Photos {current} de {total}',
        maxWidth: '100%',
        maxHeight: '100%',
        onOpen: function () {
            $overflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
        },
        onClosed: function () {
            document.body.style.overflow = $overflow;
        },
        onComplete: function () {
            $.colorbox.resize();
            wait.stop();
            //$("#cboxClose").remove();
        }
    };

    $(item).colorbox(colorbox_params);

    $("#cboxLoadingGraphic").append("<i class='ace-icon fa fa-spinner'></i>");//let's add a custom loading icon
}

function ouvrirModalAnimatedFade(selecteurModal) {
    setTimeout(function () {
        $(selecteurModal).modal({
            show: true,
            backdrop: 'static'
        });
    }, 0);

    setTimeout(function () {
        $(`${selecteurModal} .modal-animated-fade .modal-animated-fade-item`).addClass('visible');
    }, 500);
}

function fermerModalAnimatedFade(selecteurModal) {
    $(`${selecteurModal} .modal-animated-fade .modal-animated-fade-item`).removeClass('visible');
    $(selecteurModal).modal("hide");
}

// Espace de nom réservé à la déclaration des masques
var masquesSelection = {
    init: function (container) {
        if (container === undefined) container = 'body';
        $.mask.definitions['~'] = '[-?0-9]';

        if ($(container).find('.masque-matricule').length > 0) {
            IMask($(container).find('.masque-matricule')[0], {
                mask: '0000-00-0000-000-0000',
            });
        }
        $(container).find('.padNombre').padNombre({taille: 3});
        $(container).find('.masque-numerique').mask('~9999?999999999999', {placeholder: ""});
        $(container).find('.masque-telephone').mask('(999)-999-9999');
        $(container).find('.date-picker').mask('9999-99-99');
        $(container).find('.dateinput').mask('9999-99-99');
    },


    /**
     * Fonction utilisée pour "striper" les masques et ne retenir que le contenu nécessaire pour la sauvegarde dans la base de données.
     * @param {string} currentForm - Sélecteur du formulaire courant sur lequel la sauvegarde tente de s'effectuer présentement.
     * @param {string} params - Array qui contient tous les champs sérialisés pour la sauvegarde dans la BD.
     */
    striper: function (currentForm, params) {
        var donnees = params;
        var tel = currentForm.find('.masque-telephone').serializeArray(); // TODO: Boucle à rendre générique (créer une liste de array selon les classes de filtres à traiter et itérer ?)
        $.each(tel, function (idx, obj) { // TODO: Boucle non optimale O2 à valider.
            for (var i = 0; i < donnees.length; i++) {
                if (obj.name === donnees[i].name) {
                    donnees[i].value = obj.value.replace(/[^+\d.]/g, '');
                }
            }

            if (typeof (donnees) == 'object') { // DM: comme c'est le cas dans saveBlocs()
                $.each(donnees, function (idx3, donnee) {
                    $.each(donnee, function (idx2, paire) {
                        if (paire.name == obj.name) {
                            paire.value = paire.value.replace(/[^+\d.]/g, '');
                        }
                    });
                });
            }
        });

        return donnees;
    }
}; // namespace masques


function InitTable(my_table, nbColonnes, triInitial) {
    var col = [];
    for (var i = 0; i <= nbColonnes; i++) {
        col.push(null);
    }
    initTableDatatable("#" + my_table, {
        "aoColumns": col,
        "iDisplayLength": -1, //tous
        "aaSorting": triInitial, // DÉFINITION DU TRI PAR DÉFAUT À L'OUVERTURE
        "bPaginate": false,
        "bFilter": false,
        "bInfo": false
    });

}


// DM: nécessaire pour charger les contrôles SELECT avec tags
function init_chosen(blocsContainer) {
    initSelect2(blocsContainer);
}


function initSelect2(container='body') {
    var inputs = container.find(".geo-select").not('.select2-container');

    $.each(inputs, function (index, input) {
        input = $(input);

        if (!input.hasClass('geo-select-ajax')) {
            let closeWhenSelected = true;
            if(typeof input.data('stay-open') !== 'undefined') {
                closeWhenSelected = !input.data('stay-open');
            }

            /* si on a un select multiple, retirer les options vides sinon le select2 va le sélectionner par défault */
            if(input.hasAttr('multiple') && input.attr('multiple') !== '') {
                input.find("option").each(function() {
                    if($(this).val() === '') {
                        $(this).remove();
                    }
                });
            }

            /* le style responsive a été fait pour certains select2 - condition mise pour ne pas brisé les autres non resp */
            if (input.closest(".responsive-select2-container").length) {
                input.select2({
                    allowClear: true, // DM: pour afficher un X pour permettre de sélectionner "NULL"
                    placeholder: '',
                    dropdownCssClass: "responsive-select2-drop",
                    closeOnSelect: closeWhenSelected
                });
            } else {
                input.select2({
                    dropdownAutoWidth: 'true',
                    allowClear: true, // DM: pour afficher un X pour permettre de sélectionner "NULL"
                    placeholder: '',
                    closeOnSelect: closeWhenSelected
                });
            }
        } else {
            var nomChamp = input.attr('name');
            var paramsSupp = {};
            if (nomChamp == 'user') {
                initSelecteurDeRecherche($(input), "/core/get-choix-user", true, false, true, paramsSupp);
            }
        }
    });

    // TODO: déplacer vers l'init de #correction-mineure-adresse-civique
    if (container.is('#correction-mineure-adresse-civique.blocForm, .nouvelle-ligne')) {
        container.find('.select2-custom').each(function () {
            if ($(this).attr('name') == 'voiePublique') {
                initEclaterVoiePublique();
            }
        });
    }
}


function assignerNoLigneSousBloc(champsMultiple) {
    // on met un no de ligne pour chaque ligne de sous-bloc
    var lignes = champsMultiple.find('.sous-bloc-form');

    $.each(lignes, function (index, ligne) {
        $(ligne).attr('no-ligne', index + 1);
    });
}


function assignerNoLigneReperesPrint() {
    $('.reperes').each(function () {
        var repereContainer = $(this);
        var qcComposantes = repereContainer.find('[id^="qc-composante"]');
        $.each(qcComposantes, function (index, qcComposante) {
            // d'abord, on assigne à l'accordion du qc-composante le no de ligne de chaque QC, pour le retrouver plus facilement
            var idSousBlocParent = $(qcComposante).attr('id-sous-bloc-parent');
            var sousBlocQc;
            if (idSousBlocParent != 'None') {
                sousBlocQc = $('.sous-bloc-form[id-model-instance=' + idSousBlocParent + '] .qc').closest('.sous-bloc-form');
            } else {
                var idComposante = $(qcComposante).find('#container-repere').attr('id-composante');
                sousBlocQc = $('.qc').find('[name$="composante"][value="' + idComposante + '"]').closest('.sous-bloc-form');
            }
            var noLigne = sousBlocQc.attr('no-ligne');
            $(qcComposante).attr('no-ligne', noLigne);

            // ensuite, on change le no assigné au nom de la composante selon le no de ligne
            if (idSousBlocParent != 'None') {
                modifierNomReperePrint($(qcComposante), noLigne);
            }
        });

        // ensuite, on ordonne les blocs de repères par ordre de tri et par no de ligne
        ordonnerReperesPrint(repereContainer, qcComposantes);
    });
}


function modifierNomReperePrint(qcComposante, noLigne) {
    var idQcComposante = $(qcComposante).attr('id');
    var indexId = idQcComposante.lastIndexOf('-');
    if (indexId != -1) {
        var noTrouve = idQcComposante.substr(indexId + 1);
        if (noTrouve != noLigne) {
            // change le id du div
            $(qcComposante).attr('id', idQcComposante.substr(0, indexId + 1) + noLigne);
            // change le texte
            var texteRepere = $(qcComposante).find('.cell-nom-repere').first();
            var indexTexte = texteRepere.text().lastIndexOf(noTrouve);
            texteRepere.contents().last()[0].textContent = texteRepere.text().substr(0, indexTexte) + noLigne + texteRepere.text().substr(indexTexte + 1);
        }
    }
}


function ordonnerReperesPrint(repereContainer, qcComposantes) {
    var reperes = qcComposantes.detach();
    var reperesOrderedDivs = reperes.sort(function (a, b) {
        var elementA = parseInt($(a).attr('ordre-tri'));
        var elementB = parseInt($(b).attr('ordre-tri'));
        if (elementA == elementB) {
            var noLigneA = parseInt($(a).attr('no-ligne'));
            var noLigneB = parseInt($(b).attr('no-ligne'));
            return noLigneA > noLigneB ? 1 : noLigneA < noLigneB ? -1 : 0;
        }
        return elementA > elementB ? 1 : elementA < elementB ? -1 : 0;
    });
    repereContainer.first().append(reperesOrderedDivs);
    // enlever les divs de séparation
    repereContainer.find('.repere-separation').remove();
    // ajouter un div de séparation entre chaque qcComposante
    reperesOrderedDivs.before('<div class="repere-separation"></div>');
}


function initSelecteurMultiple(bloc, printMode) {
    // on assigne la sélection multiple à partir des inputs multiples: les inputs multiples peuvent être dans un bloc ou dans un sous-bloc
    var inputMultiples = bloc.find('.input-select-multiple');
    if (inputMultiples.length > 0) {

        // concaténer les valeurs des inputs d'un même parent dans un array
        var inputs = inputMultiples.find('input, select, ul.fake-select');
        var arrayParents = [];
        $.map(inputs, function (valeur) {
            var parent = $(valeur).attr('parent');
            if (arrayParents.indexOf(parent) == -1) {
                arrayParents.push(parent);
            }
        });

        // assigner les valeurs des inputs aux sélecteurs multiples
        $.each(arrayParents, function (keyParent, valeurParent) {

            var select = bloc.find('select[name="' + valeurParent + '"], ul.fake-select[name="' + valeurParent + '"]');

            // avoir les inputs de ce parent
            var inputsParent = inputs.filter('[parent="' + valeurParent + '"]');
            // avoir les valeurs des inputs dans un array
            var valeursInput = [];
            $.map(inputsParent, function (input) {
                var valeur = $(input).val();
                // si le input est un select dans un sous-bloc(ex.: bloc 61), on veux prendre son texte, qui peut être le id ou le code
                if ($(input).is('select')) {
                    var code = $($(input).prop('options')[$(input).prop('selectedIndex')]).attr('code');
                    if (code !== undefined) {
                        valeur = code;
                    }
                }
                if (valeursInput.indexOf(valeur) == -1) {
                    valeursInput.push(valeur);
                }
            });

            var options = select.is('ul') ? select.find('li.option') : select.find('option');
            var optionsAvecCode = options.filter('[code]');
            // les sélections à faire sont ceux des inputs
            var inputsSelectionnes = [];

            $.each(valeursInput, function (key, valeur) {
                var option = [];
                if (optionsAvecCode.length > 0) {
                    // dans les options du select, chercher le 'code' avec la valeur
                    option = optionsAvecCode.filter('[code="' + valeur + '"]');
                } else {
                    // dans les options du select, chercher le 'value' avec la valeur
                    option = options.filter('[value="' + valeur + '"]');
                }
                if (option.length == 1) {
                    if (!printMode) {
                        if ($.inArray($(option).val(), inputsSelectionnes) == -1) { // condition pour gérer les doublons au cas
                            inputsSelectionnes.push(select.is('ul') ? $(option).data('js') : $(option).val());
                            $(option).attr('selected', '');
                        }
                    } else {
                        $(option).addClass('selected-print');
                        $(option).removeAttr('selected'); // il faut enlever l'attribut 'selected' car on veut le gérer seulement par la classe ajoutée juste avant
                    }
                }
            });

            if (!printMode) {
                select.val(inputsSelectionnes);
                select.attr('selection-precedente', inputsSelectionnes);
            }
        });
    }
}


function getIcon(idTypeBatiment) {
    var iconFiche = '';
    if (idTypeBatiment == 1) iconFiche = 'ace-icon fa fa-home';
    if (idTypeBatiment == 2) iconFiche = 'icon-farm';
    if (idTypeBatiment == 3) iconFiche = 'ace-icon fa fa-building';
    if (idTypeBatiment == 4) iconFiche = 'ace-icon fa fa-industry';

    return iconFiche;
}


function getTitre(idFormulaire) {
    var titre = '';
    if (idFormulaire == ID_FORMULAIRE.renseignementAdministratif) titre = 'Renseignements administratifs';
    if (idFormulaire == ID_FORMULAIRE.residentiel) titre = 'Bâtiment résidentiel';
    if (idFormulaire == ID_FORMULAIRE.multi) titre = 'Bâtiment multirésidentiel';
    if (idFormulaire == ID_FORMULAIRE.terrainGeneral) titre = 'Terrain général';
    if (idFormulaire == ID_FORMULAIRE.terrainAgricoleBoise) titre = 'Terrain agricole ou boisé';
    if (idFormulaire == ID_FORMULAIRE.agricole) titre = 'Bâtiment agricole';
    if (idFormulaire == ID_FORMULAIRE.nonResidentiel) titre = 'Bâtiment non résidentiel';
    if (idFormulaire == ID_FORMULAIRE.resultatEvaluation) titre = "Résultats d'évaluation";

    return titre;
}


/**
 * Fonction d'affichage de messages Toast pour les opérations de sauvegarderDonnees()
 * */
function sauvegarderDonneesMessageToast(messageToast, nombreFormulaires, jqxhr, nbErreur, callback) {
    var message = typeof (messageToast) !== 'object' ? {} : messageToast;
    if (messageToastCompteur === nombreFormulaires - 1) {
        infos.ajouterMessageToast({
            icone: nbErreur > 0 ? 'fa-exclamation-circle' : 'fa-check-circle-o',
            iconeCouleur: nbErreur > 0 ? 'red' : 'green',
            message: nbErreur > 0 ? "Erreur de sauvegarde" + (jqxhr.responseJSON && jqxhr.responseJSON['None'] ? "<p>" + jqxhr.responseJSON['None'] + "<\p>" : '') : message.properties != 'undefined' ? typeof (message.message) != 'undefined' ? message.message : "Sauvegarde réussie" : "Sauvegarde réussie",
            type: (typeof (jqxhr) !== 'object' ? jqxhr : ((jqxhr.error.name != '') || (jqxhr.error.name != 'add')) ? 'error' : 'ok'),
            messageDuree: message.properties != 'undefined' ? typeof (message.messageDuree) != 'undefined' ? message.messageDuree : typeof (message.messageCumuler) != 'undefined' ? (message.messageCumuler ? 0 : 1500) : 1500 : 1500,
            messageCumuler: message.properties != 'undefined' ? typeof (message.message) != 'undefined' ? message.messageCumuler : 'false' : 'false',
            messageCouleur: message.properties != 'undefined' ? typeof (message.messageCouleur) != 'undefined' ? message.messageCouleur : "black" : "black"
        }, nombreFormulaires);
    }
}


function setEnteteFormulaire(headerTitre, idBatiment, idFormulaire, idUe, infoboxIdentifiant, print_mode) {
    if (print_mode == undefined) print_mode = false;

    var mun = headerTitre.attr('municipalite');
    var codeGeo = headerTitre.attr('code-geographique');
    var titreFiche = getTitre(idFormulaire);
    var exercicesFinanciers = $('#exercicesFinanciers').val();
    var titre = titreFiche + '  (' + mun + ', ' + codeGeo + ')';
    if (exercicesFinanciers !== undefined) {
        titre += ' ' + exercicesFinanciers;
    }
    headerTitre.text(titre);

    var titreClass = FORMULAIRE_CSS[idFormulaire];
    if (!print_mode) {
        headerTitre.removeClass();
        headerTitre.addClass(titreClass);
    }

    $('#container').removeClass().addClass(titreClass);

    // lors de l'impression de la fiche, cette fonction plante quand on utilise "includes",
    // alors j'ai remis l'ancienne façon
    if (idFormulaire == ID_FORMULAIRE.residentiel || idFormulaire == ID_FORMULAIRE.multi ||
        idFormulaire == ID_FORMULAIRE.agricole || idFormulaire == ID_FORMULAIRE.nonResidentiel) {
        infoboxIdentifiant.text('ID UE: ' + idUe + ' / ID Bâtiment: ' + idBatiment);
    } else {
        infoboxIdentifiant.text('ID UE: ' + idUe);
    }

    // mettre l'icône de bâtiment appropriée
    var elemIcon = infoboxIdentifiant.closest('.infobox').find('.infobox-icon > i');
    elemIcon.removeClass();

    var type_batiment = 0;

    if (idFormulaire == ID_FORMULAIRE.residentiel) {
        type_batiment = TYPE_BATIMENT.residentiel;
    }
    if (idFormulaire == ID_FORMULAIRE.multi) {
        type_batiment = TYPE_BATIMENT.multi;
    }
    if (idFormulaire == ID_FORMULAIRE.agricole) {
        type_batiment = TYPE_BATIMENT.agricole;
    }
    if (idFormulaire == ID_FORMULAIRE.nonResidentiel) {
        type_batiment = TYPE_BATIMENT.nonResidentiel;
    }

    var classIcon = getIcon(type_batiment);
    elemIcon.addClass(classIcon);
}

function updateBarreOutilsFiche(idFormulaire) {
    const listeIDFormulairesBatiment = [ID_FORMULAIRE.residentiel, ID_FORMULAIRE.multi, ID_FORMULAIRE.agricole, ID_FORMULAIRE.nonResidentiel];
    const listeIDFormulairesTerrain = [ID_FORMULAIRE.terrainGeneral, ID_FORMULAIRE.terrainAgricoleBoise];

    const btnPhotoOutilEntete = $("#btn_photo_outil_entete");

    let titleBtnImpressionFiche = "Imprimer la fiche de renseignement administratif";

    /* s'il s'agit d'un formulaire bâtiment, on veut le bouton pour l'ajout de photos */
    if($.inArray(idFormulaire, listeIDFormulairesBatiment) > -1 && $("#mode-read-only").val() === 'False') {
        btnPhotoOutilEntete.removeClass("hidden");
    } else {
        btnPhotoOutilEntete.addClass("hidden");
    }

    if($.inArray(idFormulaire, listeIDFormulairesTerrain) > -1) {
        titleBtnImpressionFiche = "Imprimer la fiche du terrain";
    } else if(idFormulaire == '8') {
        titleBtnImpressionFiche = "Imprimer la fiche des résultats d'évaluation";
    } else if(idFormulaire != '1') {
        titleBtnImpressionFiche = "Imprimer la fiche du dossier de propriété";
    }

    setTimeout(function() {
        $("#btn-imprimer-fiche").attr("title", titleBtnImpressionFiche);
    }, 1000);
}

function estFirefox() {
    return window.mozInnerScreenX != null;
}

function estKeyInArrayOfObjects(array, recherche) {
    var reponse = false;
    var resultat = reqValeurKeyInArrayOfObjects(array, recherche);
    if (typeof (resultat) != 'undefined') {
        reponse = true;
    }
    return reponse;
}

function reqValeurKeyInArrayOfObjects(array, recherche) {
    return $.grep(array, function (obj) {
        return obj.name === recherche;
    })[0];
}


// Fonctions d'utilisation des touches de clavier.
document.onkeydown = function (e) {
    var keyPressed = e.keyCode;
    if (keyPressed == 16) {
        $('html').addClass('unselectable');
        document.onkeyup = function () {
            $('html').removeClass('unselectable');
        };
    }
};


function chargerrouteinspectionGestionRoute(iduser) {
    var champDateRole = $('#modal-wizard-evenement').find('[name="routeInspection"]');
    champDateRole.find('option').remove().end();
    champDateRole.append('<option value=""></option>');
    champDateRole.select2();
    $.ajax({
        type: "GET",
        url: "/gestion-roles/route-inspection/user/" + iduser + "/",
        dataType: 'json',
        success: function (response) {

            champDateRole.find('option').remove().end();
            $.each(response, function (i, listDateRole) {
                champDateRole.append($('<option>', {
                    value: listDateRole.id_choix,
                    text: listDateRole.titre
                }));
            });
        }
    });
    // chargement des voi
}

function chargerVoiePubliqueExpUe(idMunicipalite, champVoiePublique, dateEvenement, contientUe, callback) {
    if (typeof (champVoiePublique) == 'undefined') {
        champVoiePublique = $('#voie-publique');
    }
    if (typeof (dateEvenement) == 'undefined') {
        dateEvenement = null;
    }
    if (typeof (contientUe) == 'undefined') {
        contientUe = null;
    }

    var oldVal = champVoiePublique.val();

    $('#no-civique').find('option').remove().end();
    $('#no-civique').append('<option value=""></option>');
    $('#no-civique').select2();

    var params = {date_evenement: dateEvenement};
    // on indique que la case "Recherche dans l'historique" est coché
    if ($('#exp-ue-rechercher-historique').is(':checked')) {
        params.recharger_historique = true;
    }
    params.contientUe = contientUe;

    $.ajax({
        type: "GET",
        url: "/gestion-roles/exp-ue/voie-publique/municipalite/" + idMunicipalite + "/",
        data: params,
        dataType: 'json',
        success: function (response) {

            champVoiePublique.find('option').remove().end();

            champVoiePublique.append($('<option>', {
                value: 0,
                text: champVoiePublique.attr('data-placeholder')
            }));

            //On obtiens le résultats de la requête en format json
            $.each(response.list_voie_publique, function (i, listVoiePublique) {
                // chargement des voie publiques dans le select

                var adresse_tri = listVoiePublique.adresse_tri || '';
                var contientUe = listVoiePublique.contientUe;

                champVoiePublique.append($('<option>', {
                    value: listVoiePublique.id_voie_publique,
                    text: adresse_tri,
                    contientUe: contientUe
                }));
            });

            // DM: remettre la valeur avant rechargement (si par exemple le rechargement était suite a avoir coché "Vérifier dans l'historicité")
            if (champVoiePublique.find("option[value='" + oldVal + "']").length > 0) {
                champVoiePublique.val(oldVal);
            }

            if(response.mun_bool_afficher_no_dossier_ancien){
                $('#no_dossier_ancien_div').show();
            }

            if (callback) {
                callback();
            }
        }
    });
}


function initCheckBoxWithAceIcon(container, estUnique) {

    container.find('input:checkbox.form-control.ctrl-checkbox').off('change.ctrl-checkbox').on('change.ctrl-checkbox', function () {
        var ctrl = $(this);

        // on toggle sur la classe qui affiche le crochet ou le carré vide
        var ctrlIcone = ctrl.parent().find('i');
        ctrlIcone.toggleClass('fa-square-o').toggleClass('fa-check-square-o');
        // on met le checked/unchecked dans l'attribut 'value'
        var valueFalse = ctrl.attr('value_false');
        ctrl.val(ctrl.is(':checked') ? 1 : valueFalse != undefined ? valueFalse : 0);
        // On flag le checkbox ayant été modifié pour qu'il soit sauvegardé
        if (typeof appliquerChangement !== 'undefined') appliquerChangement(ctrl);

        if (estUnique) {
            // Lorsqu'on sélectionne un des checkboxes, on vide toutes les autres pour s'assurer d'en avoir toujours seulement un
            if (ctrl.is(':checked')) {
                // On sélectionne tous les checkbox du bloc autre que celui sélectionné
                var checkboxes = container.find('input:checked:enabled').not(ctrl);
                checkboxes.prop('checked', false);
                // On flag les checkboxes ayant été modifié pour qu'ils soient sauvegardé
                if (typeof appliquerChangement !== 'undefined') appliquerChangement(checkboxes);
                // on force les autres formulaires touchés par les changements à être dans l'état modifié
                checkboxes.closest('[type="formulaire"]').attr('modifie', 'True');
                checkboxes.closest('.sous-bloc-form').attr('modifie', 'True');
                ctrlIcone = checkboxes.parent().find('i');
                // on force la classe qui affiche le carré vide
                ctrlIcone.removeClass('fa-check-square-o').addClass('fa-square-o');
                // on met le unchecked dans l'attribut 'value'
                valueFalse = ctrl.attr('value_false');
                checkboxes.val(valueFalse != undefined ? valueFalse : 0);
            }
        }
    });
}

function getBboxMunicipalite(idMunicipalite, callback) {
    var success_cb = function(response) {
        callback(response);
    }
    call_ajax(`/fiche_role/municipalite/${idMunicipalite}/bbox/`, 'GET', null, success_cb, null, false)

}

function epurerListeFiltresPost(listeFiltresDef) {
    var listeFiltres = [];
    $.each(listeFiltresDef.champs, function (nom, valeur) {
        var filtre = {
            nom: nom,
            titre: valeur.parametres[0].titre,
            filtres: valeur.filtres,
            whereNo: valeur.parametres[0].whereNo,
            donneeForm: valeur.parametres[0].donneeForm,
            contenu: valeur.parametres[0].contenu
        };
        listeFiltres.push(filtre);
    });

    return listeFiltres;
}


function dateToStrYmd(date) {
    var day = ("0" + date.getDate()).slice(-2);
    var month = ("0" + (date.getMonth() + 1)).slice(-2);
    var dateStr = date.getFullYear() + "-" + (month) + "-" + (day);
    return dateStr;
}

/* prevent fixed navbar to overlay over page content */
if ($(".navbar-fixed-container").length) {
    var navbarContainer = $(".navbar-fixed-container");
    var navbar = $(".navbar-fixed-top");
    var navbarHeight;
    if ($(".sidefixed-responsive").length) {
        /* if sidebar fixed exists - edit its top position to prevent overlay */
        var sidefixed = $(".sidefixed-responsive");
    }

    setNavbarContainerHeight();

    $(window).load(function () {
        setNavbarContainerHeight();
    });

    /* make sure it adapt on resize too! */
    $(window).resize(function () {
        setNavbarContainerHeight();
    });

    $(window).on("orientationchange", function () {
        setNavbarContainerHeight();
    });

    /* put a height on the container to prevent content going behind the fixed navbar */
    function setNavbarContainerHeight() {
        navbarHeight = $(navbar).outerHeight();
        $(navbarContainer).css("height", navbarHeight + "px");

        if ($(".sidefixed-responsive").length) {
            $(sidefixed).css("top", navbarHeight + "px");
        }
    }
}

/* if sidebar fixed responsive exists, add class to body when its open to make sure user can access all items on mobile */
if ($(".sidefixed-responsive").length) {
    $("#menu-toggler").click(function () {
        if (!$(".sidefixed-responsive").hasClass("display")) {
            $("body").addClass("sidebar-open");
        } else {
            $("body").removeClass("sidebar-open");
        }
    });

    /* on mobile, close menu when selecting an item - handle differently based on chosen menu type (menu min or not) */
    $(".sidefixed-responsive a[href='#']").click(function () {
        var parent_sidebar = $(this).closest(".sidefixed-responsive");
        if ($(parent_sidebar).hasClass("menu-min")) {
            if ($(this).hasClass("submenu-text")) {
                hideSidebarMenu(parent_sidebar);
            }
        } else {
            hideSidebarMenu(parent_sidebar);
        }
    });

    function hideSidebarMenu(parent_sidebar) {
        if ($(parent_sidebar).hasClass("display") && $(window).width() <= 510) {
            $(parent_sidebar).removeClass("display");
            $(".navbar-toggle").removeClass("display");
            $("body").removeClass("sidebar-open");
        }
    }
}


function initFixTopItem() {
    if ($(".widget-fixtop-container").length && $(".widget-fixtop").length) {
        var widget_item = $(".widget-fixtop");
        var widget_height = $(".widget-fixtop-content").outerHeight(true);
        var widget_container = $(".widget-fixtop-container");
        var widget_container_width = $(widget_container).outerWidth();

        $(widget_container).css("height", widget_height + "px");

        $(widget_item).css({
            "position": "fixed",
            "z-index": "100",
            "width": widget_container_width + "px"
        });
    }
}

/* custom accordion */
$(document).on('click', '.accordion-custom .accordion-custom-link', function () {
    var collapseLink = "#" + $(this).attr("data-accordion-link");
    var collapseItem = $(this).closest(".accordion-custom").find(collapseLink);

    if ($(collapseItem).is(":hidden")) {
        $(this).closest(".accordion-custom").find(".accordion-custom-link-arrow").addClass("accordion-custom-link-arrow-open");
        $(collapseItem).slideDown();
    } else {
        $(this).closest(".accordion-custom").find(".accordion-custom-link-arrow").removeClass("accordion-custom-link-arrow-open");
        $(collapseItem).slideUp();
    }
});


function remplirLabelTotaux() {
    $(".widget-body-w-dynamic-label").each(function () {
        var label_text = "";
        var label_to_fill = "";
        for (var i = 1; i <= 7; i++) {
            label_text = $(this).find("#form-jour" + i + "-label").text();
            label_to_fill = $(this).find(".totaux-form-jour" + i + "-label");
            if (label_text != "" && label_to_fill != "") {
                $(label_to_fill).text(label_text);
            }
        }
    });
}


//fonctionnalités des boutons custom btn-with-options
$(document).on('click', '.btn-with-options .btn-options-text', function () {
    var newHeight;
    var parent = $(this).parent();
    if ($(parent).hasClass('open')) {
        newHeight = $(this).outerHeight();
        $(parent).removeClass('open');
    } else {
        newHeight = $(this).outerHeight() + $(this).siblings('.btn-options-list').outerHeight();
        $(parent).addClass('open');
    }
    $(parent).css('height', newHeight + 'px');
});

// desactiver la feature des navigateurs chromium permettant de
// modifier les nombres au scroll dans les input .fake-number-input
$(document).on('focus', '.fake-number-input', function () {
    $(this).on('wheel.disableScroll', function (e) {
        e.preventDefault();
    });
});

$(document).on('blur', '.fake-number-input', function () {
    $(this).off('wheel.disableScroll');
});

/* Modal revenu, anchors sur les boutons - slimscroll */
$(document).on('click', '.modal-revenu-anchor-btn', function () {
    var modal_parent = $(this).closest("#modal-step-contents");
    var modal_revenu = $(this).closest("#modal-revenu");
    var element_anchor = $(this).attr("href");

    var scroll_position = $(element_anchor).offset().top - $(modal_revenu).offset().top;

    $(modal_parent).slimScroll({
        scrollTo: scroll_position,
        animate: true
    });
});

$.fn.hasAttr = function (name) {
    return this.attr(name) !== undefined;
};

$.fn.padNombre = function (options) {
    var settings = $.extend({
        // These are the defaults.
        taille: 3,
        caractere: '0'
    }, options);

    this.change(function () {
        var valeur_champ = $(this).val() + '';
        var resultat = valeur_champ.length >= settings.taille ? valeur_champ : new Array(settings.taille - valeur_champ.length + 1).join(settings.caractere) + valeur_champ;
        return $(this).val(resultat);
    });
};

$.fn.multiSelectTable = function () {
    var list = $(this).selector;
    return this.each(function () {
        $(document).off('click', list + ' > *').on('click', list + ' > *', function (e) {
            var row = $(e.target).closest('tr');
            if (!$(row).hasClass('selected')) {
                $(list).find('input.check-taj:checked').prop('checked', false).trigger("change");
                $(list).find('tr.selected').removeClass('selected');
                $(row).addClass('selected');
                $(row).find('input.check-taj').prop('checked', true);
            } else {
                if ($(e.target).prev(':checkbox').hasClass('check-taj') && !$(row).hasClass('selected')) {
                    $(row).addClass('selected');
                } else {
                    $(row).removeClass('selected');
                    if (!$(e.target).prev(':checkbox').hasClass('check-taj') || !$(row).hasClass('selected')) {
                        $(row).find('input.check-taj').prop('checked', false);
                    }
                }
            }
            return true;
        });
    });
};

function remove_duplicates_array(arr) {
    return Array.from(new Set(arr));
}

function getBaseMap(avant_apres) {
    /* options peut etre modifiable pour une couche dans un module spécifique
     exemple osm.options.maxZoom = 21;
    * */

    //On définit ici les layers de base de Google et autres par défaut avec le niveau de zoom maximal fournit par le service
    googleStreets = L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
        maxZoom: 22,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        id_map_layer_hardcoded: 2,
    });

    googleStreetsApres = googleStreetsCout = L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
        maxZoom: 22,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        id_map_layer_hardcoded: 22,
    });

    googleStreetsTerrainAgricoleBoise = L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
        maxZoom: 22,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        id_map_layer_hardcoded: 222,
    });

    googleHybrid = L.tileLayer('https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', {
        maxZoom: 21,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        id_map_layer_hardcoded: 3,
    });

    googleHybridApres = L.tileLayer('https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', {
        maxZoom: 21,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        id_map_layer_hardcoded: 33,
    });

    googleSat = L.tileLayer('https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
        maxZoom: 21,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        id_map_layer_hardcoded: 4,
    });

    googleSatApres = L.tileLayer('https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
        maxZoom: 21,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        id_map_layer_hardcoded: 44,
    });

    googleTerrain = L.tileLayer('https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}', {
        maxZoom: 22,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        id_map_layer_hardcoded: 5,
    });

    googleTerrainApres = L.tileLayer('https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}', {
        maxZoom: 22,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        id_map_layer_hardcoded: 55,
    });

    osm = new L.TileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        id_map_layer_hardcoded: 1,
        maxZoom: 19
    });

    //Ortho (MFFP)
    Inventaire_Ecoforestier = L.tileLayer.wms('https://servicesmatriciels.mern.gouv.qc.ca/erdas-iws/ogc/wms/Inventaire_Ecoforestier?', {
        layers: 'Inventaire_Ecoforestier',
        id_map_layer_hardcoded: 6,
        maxZoom: 24
    });

    circulation_routier = L.tileLayer.wms('https://ws.mapserver.transports.gouv.qc.ca/swtq?', {
        layers: 'circulation_routier',
        id_map_layer_hardcoded: 7,
        maxZoom: 24
    });

    aq_camion = L.tileLayer.wms('https://ws.mapserver.transports.gouv.qc.ca/swtq?', {
        layers: 'aq_camion',
        id_map_layer_hardcoded: 8,
        maxZoom: 24
    });

    lidar_ombre = L.tileLayer.wms('https://geoegl.msp.gouv.qc.ca/ws/mffpecofor.fcgi?', {
        layers: 'lidar_ombre',
        id_map_layer_hardcoded: 10,
        maxZoom: 24
    });

    bgr_v_sous_route_res_sup_act = L.tileLayer.wms('https://ws.mapserver.transports.gouv.qc.ca/swtq?', {
        layers: 'bgr_v_sous_route_res_sup_act',
        id_map_layer_hardcoded: 9,
        maxZoom: 24
    });

    blank = L.tileLayer('', {
        id_map_layer_hardcoded: 11,
        maxZoom: 24
    });
    liste_carte_de_base = {
        'osm': osm,
        'googleStreets': googleStreets,
        'googleHybrid': googleHybrid,
        'googleSat': googleSat,
        'googleTerrain': googleTerrain,
        'roads': roads,
        'Inventaire_Ecoforestier': Inventaire_Ecoforestier,
        'circulation_routier': circulation_routier,
        'aq_camion': aq_camion,
        'bgr_v_sous_route_res_sup_act': bgr_v_sous_route_res_sup_act,
        'lidar_ombre': lidar_ombre,
        'blank': blank
    }
    var privateKeyidMapkitMutant = $("#privateKeyidMapkitMutant").val();

    var maxZoomMapkitMutant = 19;

    roads = L.mapkitMutant({
        // valid values for 'type' are 'default', 'satellite' and 'hybrid'
        type: 'hybrid',
        authorizationCallback: function (done) {
            done(privateKeyidMapkitMutant);
        },
        language: 'fr',
        // For debugging purposes only. Displays a L.Rectangle on the
        // visible bounds ("region") of the mutant.
        debugRectangle: true,
        //minZoom: 3,
        maxZoom: maxZoomMapkitMutant,
        id_map_layer_hardcoded: 12
    });

    roads.on('add', function () {
        map.setMaxZoom(maxZoomMapkitMutant); //On restreint le maxZoom du viewer au max zoom de la couche car elle déraille si on continue de zoomer
        //map.setMinZoom(3);
    });

    roads.on('remove', function () {
        map.setMaxZoom(24); //On remet le zoom au maximum permis de notre viewer Leaflet
        //map.setMinZoom(1);
    });
    var baseMaps;
    var groupeBaseExpanded = $("#leafletCouchesBaseExpanded").val() == 'true';

    if (avant_apres == 'carte_1') {
        baseMaps = [
            {
                groupName: "Carte de base",
                expanded: groupeBaseExpanded,
                layers: {
                    // base layer en dur dans le code
                    'OpenStreetMap': osm,//id_map_layer_hardcoded=1
                    'Google Maps': googleStreets,//id_map_layer_hardcoded=2
                    'Google Hybride': googleHybrid,//id_map_layer_hardcoded=3
                    'Google Sat': googleSat,//id_map_layer_hardcoded=4
                    'Google Terrain': googleTerrain,//id_map_layer_hardcoded=5
                    'Apple Hybride': roads, //id_map_layer_hardcoded=12
                    'Ortho (MFFP)': Inventaire_Ecoforestier,//id_map_layer_hardcoded=6
                    'Débits de circul. (TQ)': circulation_routier,//id_map_layer_hardcoded=7
                    'Rés. de camionnage (TQ)': aq_camion,//id_map_layer_hardcoded=8
                    'Rés. routier-RTSS (TQ)': bgr_v_sous_route_res_sup_act,//id_map_layer_hardcoded=9
                    'Lidar (MFFP)': lidar_ombre,//id_map_layer_hardcoded=10
                    'Aucune carte de base': blank//id_map_layer_hardcoded=11
                }
            }
        ];
    } else {
        baseMaps = [{
            groupName: "Carte de base",
            expanded: groupeBaseExpanded,
            layers: {

                'OpenStreetMap': osm,
                'Google Maps': googleStreetsApres,
                'Google Hybride': googleHybridApres,
                'Google Sat': googleSatApres,
                'Google Terrain': googleTerrainApres,
                'Apple Hybride': roads,
                'Lidar (MFFP)': lidar_ombre,//id_map_layer_hardcoded=10
                'Aucune carte de base': blank//id_map_layer_hardcoded=11
            }
        }];
    }

    return baseMaps;
}


$.fn.daterangepicker.defaultOptions = {
    singleDatePicker: true,
    showDropdowns: true,
    locale: {
        applyLabel: 'Choisir',
        clearLabel: 'Vider',
        cancelLabel: 'Annuler',
        fromLabel: 'De',
        toLabel: 'À',
        weekLabel: 'S',
        customRangeLabel: 'Plage personnalisée',
        daysOfWeek: moment()._weekdaysMin,
        monthNames: moment()._monthsShort,
        firstDay: 0,
        format: "YYYY-MM-DD",
    },
    autoApply: true,
    maxDate: moment().add('years', 10)._d,
    minYear: 1950,
    linkedCalendars: false
};

function is_evb_tablette(){
    return window.evb_tablette || (
        window.PointerEvent && navigator.maxTouchPoints > 1 && (navigator.platform === 'Win32' || navigator.platform === 'Win64' || /MacIntel/.test(navigator.platform) || /iPad|iPhone|iPod/.test(navigator.platform))
    );
}

$.fn.extend({
    hasClasses: function (selectors) {
        var self = this;
        for (var i in selectors) {
            if ($(self).hasClass(selectors[i]))
                return true;
        }
        return false;
    },
    addClasses: function (selectors) {
        var self = this;
        for (var i in selectors) {
            $(self).addClass(selectors[i]);
        }
    },
    removeClasses: function (selectors) {
        var self = this;
        for (var i in selectors) {
            $(self).removeClass(selectors[i]);
        }
    }
});
